<template>
  <div id="contractAdd">
    <van-steps
      class="step"
      @click-step="
        (item) => {
          if (activeMax > item || activeMax == item) {
            active = item;
          }
        }
      "
      :active="active"
      active-color="#FD7E2D"
    >
      <van-step>基础信息</van-step>

      <van-step>租期信息</van-step>

      <van-step>资产信息</van-step>

      <van-step>附件信息</van-step>
    </van-steps>

    <!-- 第一步 -->

    <div v-if="active === 0" class="form1">
      <van-form ref="form1" label-width="110px" input-align="right">
        <van-field
          readonly
          :clickable="!disable.house"
          required
          :disabled="disable.house"
          name="house"
          :value="houseNow.address"
          label="房源"
          placeholder="点击搜索房源>"
          @click="
            (item) => {
              if (!disable.house) {
                showHouse = true;

                searchValueHouse = '';
                showHouse;
              }
            }
          "
          :rules="[{ required: true, message: '请选择房源' }]"
        />

        <van-field
          name="出租方式"
          label="出租方式"
          required
          :rules="[{ validator: validRentType, message: '请选择预定方式' }]"
        >
          <template #input v-if="active === 0">
            <van-radio-group
              v-model="rentTypeNow"
              :disabled="disable.room"
              direction="horizontal"
            >
              <van-radio
                v-for="item in rentTypeList"
                :key="item.roomNo"
                :name="item.roomNo"
                :disabled="!item.show || (!item.roomNo && item.type == 2)"
                @click="
                  changeRentType(
                    item.roomNo,

                    !item.show || (!item.roomNo && item.type == 2)
                  )
                "
                >{{ item.roomNo ? item.roomNo : "整租" }}</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>
        <!-- 租赁面积 -->
        <van-field
          @focus="End($event)"
          type="number"
          readonly
          v-model="acreage"
          name="email"
          label="租赁面积"
        />
        <van-field
          readonly
          :clickable="!disable.customer"
          required
          :disabled="disable.customer"
          name="租客手机号"
          :value="form.customerPhone"
          label="租客手机号"
          placeholder="点击搜索客户>"
          @click="
            (item) => {
              if (!disable.customer) {
                showCustomer = true;

                searchValueCustomer = '';

                customerList = [];
              }
            }
          "
          maxlength="11"
          :rules="[
            { required: true, message: '请填写手机号' },

            { validator: validPhone, message: '请输入正确手机号' },
          ]"
        />

        <van-field
          required
          v-model="form.customerName"
          name="name"
          label="姓名"
          disabled
          placeholder="点击填写"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />

        <van-field
          readonly
          clickable
          required
          disabled
          name="idType"
          :value="idTypeList[form.idType - 1]"
          label="证件类型"
          placeholder="点击选择>"
          :rules="[{ required: true, message: '请选择证件类型' }]"
        />

        <div class="field van-cell--required">签约人证件照</div>

        <div class="body">
          <div class="picCard">
            <van-uploader
              :before-read="beforeRead"
              :after-read="
               contractFrontSuccess
              "
              v-model="contractorFront"
              :deletable="
                form.idType == 2 || form.idType == 3 || form.idType == 7
              "
              :max-count="1"
            />

            <div class="text">
              <van-field
                value="正面"
                name="contractorFront"
                disabled
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(contractorFront.length) || !imgUp;
                    },

                    message: '请上传正面图',
                  },
                ]"
              />
            </div>
          </div>

          <div class="picCard">
            <van-uploader
              :before-read="beforeRead"
              :after-read="
               contractBackSuccess
              "
              v-model="contractorBack"
              :deletable="
                form.idType == 2 || form.idType == 3 || form.idType == 7
              "
              :max-count="1"
            />

            <div class="text">
              <van-field
                value="反面"
                name="contractorBack"
                disabled
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(contractorBack.length) || !imgUp;
                    },

                    message: '请上传反面图',
                  },
                ]"
              />
            </div>
          </div>
        </div>

        <van-field
          type="text"
          required
          :disabled="
            !(form.idType == 2 || form.idType == 3 || form.idType == 7)
          "
          @input="idNoChange"
          v-model="form.idNo"
          name="idNo"
          label="证件号码"
          placeholder="点击填写"
          :rules="[
            { required: true, message: '请填写证件号码' },

            { validator: validIdNo1, message: '请输入正确的身份证' },
          ]"
        />

        <van-field
          name="客户类型"
          label="客户类型"
          required
          :rules="[
            {
              validator: (item) => {
                return Boolean(form.customerType);
              },

              message: '请选择客户类型',
            },
          ]"
        >
          <template #input v-if="active === 0">
            <van-radio-group
              v-model="form.customerType"
              :disabled="
                Boolean($route.query.changeHouseContractId) || form.status == 3
              "
              direction="horizontal"
            >
              <van-radio :name="1" @click="changeCustomerType(1)"
                >个人客户</van-radio
              >

              <van-radio :name="2" @click="changeCustomerType(2)"
                >企业客户</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-if="eleWaterMeterShow"
          name="是否自动断电"
          label="是否自动断电"
          required
          :rules="[
            { required: true, message: '请选择是否自动断电' },

          ]"
        >
          <template #input>
            <van-radio-group v-model="form.autoPowerOff" direction="horizontal">
              <van-radio :name="0">不断电</van-radio>

              <van-radio :name="1">断电</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div class="body" v-if="form.customerType == '2'">
          <div class="picCard" v-if="form.customerType == 2">
            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  businessLicense = [
                    {
                      url: upload_qiniu_addr + item.file.key,

                      isImage: true,
                    },
                  ];

                  $refs.form1.resetValidation('businessLicense');
                }
              "
              v-model="businessLicense"
              :max-count="1"
            />

            <div class="text">
              <van-field
                value="营业执照"
                name="businessLicense"
                disabled
                :rules="[
                  {
                    validator: (item) => {
                      return (
                        (form.customerType == 2
                          ? Boolean(businessLicense.length)
                          : true) || !imgUp
                      );
                    },

                    message: '请上传营业执照图',
                  },
                ]"
              />
            </div>
          </div>
        </div>

        <van-field
          required
          v-if="form.customerType == '2'"
          v-model="form.orgName"
          name="orgName"
          label="企业名称"
          placeholder="点击填写"
          :rules="[{ required: true, message: '请填写企业名称' }]"
        />

        <van-field
          required
          v-if="form.customerType == '2'"
          v-model="form.orgNo"
          name="orgNo"
          label="社会信用代码"
          placeholder="点击填写"
          :rules="[{ required: true, message: '请填写社会信用代码' }]"
        />

        <van-field
          @focus="End($event)"
          type="email"
          v-model="form.email"
          name="email"
          label="电子邮箱"
          placeholder="点击填写"
          :rules="[{ validator: validEmail, message: '请输入正确邮箱' }]"
        />

        <van-field
          @focus="End($event)"
          v-model="form.company"
          name="company"
          label="工作单位"
          placeholder="点击填写"
        />

        <van-field
          @focus="End($event)"
          v-model="form.position"
          name="position"
          label="职位"
          placeholder="点击填写"
        />

        <van-field
          required
          @focus="End($event)"
          v-model="form.contactName"
          name="contactName"
          label="紧急联系人姓名"
          placeholder="点击填写"
          :rules="[{ required: true, message: '请填写紧急联系人姓名' }]"
        />

        <van-field
          readonly
          clickable
          required
          name="contactRelation"
          :value="contactList[form.contactRelation - 1]"
          label="紧急联系人关系"
          placeholder="点击选择>"
          @click="
            (item) => {
              if (!$route.query.changeHouseContractId) {
                showContact = true;
              }
            }
          "
          :rules="[{ required: true, message: '请选择紧急联系人关系' }]"
        />

        <van-field
          required
          @focus="End($event)"
          v-model="form.contactPhone"
          type="tel"
          name="contactPhone"
          label="紧急联系人电话"
          placeholder="点击填写"
          maxlength="11"
          :rules="[
            { required: true, message: '请填写紧急联系人电话' },

            { validator: validPhone, message: '请输入正确手机号' },

            {
              validator: (item) => {
                return Boolean(form.contactPhone != form.customerPhone);
              },

              message: '紧急联系人电话不可与租客相同',
            },
          ]"
        />

        <van-field name="persons" label="入住人数" required>
          <template #input v-if="active === 0">
            <van-stepper
              v-model="form.persons"
              min="0"
              max="20"
              integer
              disable-input
              @plus="
                form.customerPersonList.push({
                  name: '',

                  phone: '',
                  id: '',
                  idType: '',

                  idCard: '',

                  frontCertificateUrl: '',

                  backCertificateUrl: '',
                });

                cardList.push({
                  prevIdCard: [],

                  backIdCard: [],
                });
              "
              @minus="
                form.customerPersonList.pop();

                cardList.pop();
              "
            />
          </template>
        </van-field>

        <div
          style="border-bottom: 0.02667rem solid #ebedf0; margin: 0.1rem 0"
          v-for="(item, index) in form.customerPersonList"
          :key="index"
        >
          <van-field
            required
            readonly
            :name="'personphone' + index"
            type="tel"
            :label="'租客' + (index + 1) + '电话'"
            :value="item.phone"
            placeholder="点击搜索租客>"
            @click="
              (item) => {
                showCheckPerson = true;

                searchValueCheckPerson = '';
                checkPersonIndex = index;
                CheckPersonList = [];
              }
            "
            maxlength="11"
            :rules="[
              { required: true, message: '请填写租客' + (index + 1) + '电话' },

              { validator: validPhone, message: '请输入正确手机号' },
            ]"
          />
          <van-field
            readonly
            clickable
            disabled
            required
            :name="'personidType' + index"
            :value="idTypeList[item.idType - 1]"
            :label="'租客' + (index + 1) + '证件类型'"
            placeholder="点击选择>"
            @click="
              (item) => {
                personIndex = index;
              }
            "
            :rules="[{ required: true, message: '请选择租客证件类型' }]"
          />

          <div class="body">
            <div class="picCard">
              <van-uploader
                :disabled="!item.name"
                :deletable="!(item.idType == 1) &&  !(form.customerPhone == item.phone)"
                :before-read="beforeRead"
                :after-read="
                  (fileItem) => {
                    cardList[index].prevIdCard = [
                      {
                        url: upload_qiniu_addr + fileItem.file.key + `${isAddTextMask?imgMaskUrl:''}`,

                        isImage: true,
                      },
                    ];

                    item.frontCertificateUrl =
                      upload_qiniu_addr + fileItem.file.key;

                    $refs.form1.resetValidation('prevcard' + index);
                  }
                "
                v-model="cardList[index].prevIdCard"
                :max-count="1"
              />

              <div class="text">
                <van-field
                  value="正面"
                  :name="'prevcard' + index"
                  disabled
                  :rules="[
                    {
                      validator: (item) => {
                        return (
                          Boolean(cardList[index].prevIdCard.length) || !imgUp
                        );
                      },

                      message: '请上传正面图',
                    },
                  ]"
                />
              </div>
            </div>

            <div class="picCard">
              <van-uploader
                :disabled="!item.name"
                :deletable="!(item.idType == 1)&&  !(form.customerPhone == item.phone)"
                :before-read="beforeRead"
                :after-read="
                  (fileItem) => {
                    cardList[index].backIdCard = [
                      {
                        url: upload_qiniu_addr + fileItem.file.key  + `${isAddTextMask?imgMaskUrl:''}`,

                        isImage: true,
                      },
                    ];

                    item.backCertificateUrl =
                      upload_qiniu_addr + fileItem.file.key;

                    $refs.form1.resetValidation('backcard' + index);
                  }
                "
                v-model="cardList[index].backIdCard"
                :max-count="1"
              />

              <div class="text">
                <van-field
                  value="反面"
                  :name="'backcard' + index"
                  disabled
                  :rules="[
                    {
                      validator: (item) => {
                        return (
                          Boolean(cardList[index].backIdCard.length) || !imgUp
                        );
                      },

                      message: '请上传反面图',
                    },
                  ]"
                />
              </div>
            </div>
          </div>

          <van-field
            required
            @focus="End($event)"
            :disabled="item.idType == 1 || !item.phone || form.customerPhone == item.phone"
            v-model="item.name"
            :name="'personname' + index"
            :label="'租客' + (index + 1) + '姓名'"
            placeholder="点击填写"
            :rules="[
              { required: true, message: '请填写租客' + (index + 1) + '姓名' },
            ]"
          />

          <van-field
            @focus="End($event)"
            required
            :disabled="item.idType == 1 || !item.phone || form.customerPhone == item.phone"
            class="border"
            v-model="item.idCard"
            :name="'personidCard' + index"
            :label="'租客' + (index + 1) + '证件号'"
            maxlength="18"
            placeholder="点击填写"
            :rules="[
              {
                required: true,

                message: '请填写租客' + (index + 1) + '身份证',
              },

              {
                validator: (e) => {
                  if (item.idType == 1) {
                    return Boolean(validIdNo(e));
                  } else {
                    return true;
                  }
                },

                message: '请输入正确的身份证',
              },
            ]"
          />
        </div>
      </van-form>

      <div style="height: 1.2rem"></div>

      <div class="btn">
        <van-button
          round
          block
          type="primary"
          @click="next1"
          :disabled="nextDisabled"
          >下一步</van-button
        >
      </div>
    </div>

    <!-- 第二步 -->

    <div v-if="active === 1" class="form2">
      <van-form ref="form2" label-width="110px" input-align="right" key="form2">
        <van-field
          readonly
          clickable
          required
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.type == 2 || form.status == 3)) ||
                ($route.query.oldContractId &&
                  (form.type == 2 || form.type == 3)) ||
                $route.query.prevContractId
            )
          "
          name="startDate"
          :value="form.startDate ? form.startDate.slice(0, 10) : ''"
          label="开始日期"
          placeholder="点击选择日期>"
          @click="
            (item) => {
              if (
                !Boolean(
                  ($route.query.contractId &&
                    (form.type == 2 || form.status == 3)) ||
                    ($route.query.oldContractId &&
                      (form.type == 2 || form.type == 3)) ||
                    $route.query.prevContractId
                )
              ) {
                startRangeDate = form.startRangeDate
                  ? new Date(form.startRangeDate.slice(0, 10))
                  : startRangeDate;

                endRangeDate = form.endRangeDate
                  ? new Date(form.endRangeDate.slice(0, 10))
                  : endRangeDate;

                showStartDate = true;
              }
            }
          "
          :rules="[{ required: true, message: '请选择日期' }]"
        />

        <van-field
          readonly
          clickable
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.status == 3 || form.type == 4)) ||
                $route.query.transferContractId
            )
          "
          required
          name="activity"
          :value="
            !form.activityId
              ? '不参加'
              : activity.name
          "
          label="参加活动"
          placeholder="点击选择>"
          @click="
            (item) => {
              if (
                !Boolean(
                  ($route.query.contractId &&
                    (form.status == 3 || form.type == 4)) ||
                    $route.query.transferContractId
                )
              ) {
                 (showActivity = true) ;
              }
            }
          "
         
        />

        <van-field
          readonly
          :value="
            propertyContract.quitDate
              ? propertyContract.quitDate.slice(0, 10)
              : ''
          "
          label="业主合约到期日"
        />

        <van-field
          readonly
          :value="propertyContract.number"
          label="业主合约编码"
        />

        <van-field
          v-model="form.leaseMonth"
          type="digit"
          @blur="
            getSku();

            getEndDate();
           
            $refs.form2.validate('leaseDay');
          "
          @change="changeMonth"
          name="leaseMonth"
          label="租期（月）"
          placeholder="点击填写"
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.status == 3 || form.type == 4)) ||
                ($route.query.oldContractId && form.type == 3) ||
                $route.query.transferContractId ||
                !form.startDate|| this.activity.type == 3
            )
          "
          :rules="[
            {
              validator: (item) => {
                return Boolean(form.leaseMonth/1 || form.leaseDay/1);
              },

              message: '请填写租期',
            },
             
          ]"
        />

        <van-field
          v-model="form.leaseDay"
          type="digit"
          @change="changeMonth"
          @blur="
            getSku();

            getEndDate();

            $refs.form2.validate('leaseMonth');
          "
          name="leaseDay"
          label="租期（天）"
          placeholder="点击填写"
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.status == 3 || form.type == 4)) ||
                ($route.query.oldContractId && form.type == 3) ||
                $route.query.transferContractId ||
                !form.startDate|| this.activity.type ==3
            )
          "
          :rules="[
            {
              validator: (item) => {
                return Boolean(form.leaseMonth/1 || form.leaseDay/1);
              },

              message: '请填写租期',
            },

            {
              validator: (item) => {
                return !Boolean(leaseDayValid && form.leaseDay > leaseDayValid);
              },

              message: '当租期大于1个月时请输入月数+天数',
            },
          ]"
        />

        <van-field
          readonly
          name="endDate"
          disabled
          :value="form.endDate ? form.endDate.slice(0, 10) : ''"
          label="结束日期"
          placeholder="自动计算，不可修改"
          :rules="[
            {
              validator: (item) => {
                if(!$route.query.changeHouseContractId){
                   return oldContract.endDate
                  ? !Boolean(oldContract.endDate > form.endDate)
                  : true;
                }else{
                  return true
                }
               
              },

              message:
                '结束日期必须大于等于上一份合约到期日（' +
                oldContract.endDate.slice(0, 10) +
                '）',
            },

            {
              validator: (item) => {
                return propertyContract.quitDate
                  ? !Boolean(propertyContract.quitDate < form.endDate)
                  : true;
              },

              message: '结束日期必须小于等于业主合约合约到期日',
            },
          ]"
        />

        <van-field
          readonly
          clickable
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.status == 3 || form.type == 4)) ||
                $route.query.transferContractId
            )
          "
          required
          name="payMonth"
          :value="
            !form.payMonth && !form.depositMonth
              ? ''
              : form.payMonth == 999
              ? '全额付'
              : '付' + form.payMonth + '押' + form.depositMonth
          "
          label="支付方式"
          placeholder="点击选择>"
          @click="
            (item) => {
              if (
                !Boolean(
                  ($route.query.contractId &&
                    (form.status == 3 || form.type == 4)) ||
                    $route.query.transferContractId
                )
              ) {
                form.leaseMonth || form.leaseDay ? (showPayType = true) : '';
              }
            }
          "
          :rules="[
            {
              validator: (item) => {
                return Boolean(form.leaseMonth || form.leaseDay);
              },

              message: '请先选择租期',
            },

            {
              validator: (item) => {
                return Boolean(form.payMonth);
              },

              message: '请选择支付方式',
            },
          ]"
        />

        <van-field
          v-model="form.rental"
          name="rental"
          type="digit"
          disabled
          label="租金"
          placeholder="点击填写"
        />
         <van-field v-if="form.activityId"
          v-model="form.activityRental"
          name="activityRental"
          type="number"
          disabled
          label="活动价格"
          
        />
        <van-field
          v-model="form.deposit"
          name="deposit"
          type="digit"
          label="押金"
          placeholder="点击填写"
          :disabled="form.type == 4 || form.status == 3 || !depositInputEnabled"
          :rules="[
            {
              validator: (item) => {
                return Boolean(form.deposit);
              },
              message: '请填写押金',
            },

            {
              validator: validNum0,

              message: '押金必须为正整数或0',
            },

            {
              validator: validDeposit,

              message: '押金必须大于或等于支付方式对应的押金金额',
            },
          ]"
        />

        <van-field
          v-model="form.amount"
          name="amount"
          type="digit"
          disabled
          label="定金"
          placeholder
        />

        <van-field
          v-model="form.advanceFee"
          name="advanceFee"
          label="水电燃预缴费"
          type="digit"
          required
          placeholder="点击填写"
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.status == 3 || form.type == 4)) ||
                !prepayment.isUpdate
            )
          "
          :rules="[
            {
              validator: (item) => {
                return item !== '';
              },

              message: '请填写水电燃预缴费',
            },
            {
              validator: advanceFeeValid1,

              message: '水电燃预缴费不能为0',
            },
            {
              validator: advanceFeeValid2,

              message: `水电燃预缴费必须为${this.prepayment.basePrice}的整数倍`,
            },
          ]"
        />

        <van-field
          v-model="form.serviceFee"
          name="serviceFee"
          label="服务费"
          type="digit"
          placeholder="点击填写"
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.status == 3 || form.type == 4)) ||
                $route.query.transferContractId
            )
          "
        />

        <van-field
          v-model="form.condoFee"
          name="condoFee"
          label="物业费"
          type="digit"
          required
          placeholder="点击填写"
          :disabled="
            Boolean(
              ($route.query.contractId &&
                (form.status == 3 || form.type == 4)) ||
                $route.query.transferContractId
            )
          "
          :rules="[
            {
              validator: (item) => {
                return item !== '';
              },

              message: '请填写物业费',
            },

            {
              validator: validNum0Decimal2,

              message: '物业费必须大于等于0且最多保留两位小数',
            },
          ]"
        />

        <van-field :border="false" readonly label="其他费用" />

        <div class="field">
          一次性费用

          <span class="button-mini">
            <van-icon
              name="plus"
              @click="
                (item) => {
                  if (
                    !Boolean(
                      ($route.query.contractId &&
                        (form.status == 3 || form.type == 4)) ||
                        $route.query.transferContractId
                    )
                  ) {
                    showFeeS = true;

                    amountType = 1;
                  }
                }
              "
            />
          </span>
        </div>

        <div
          class="unit"
          v-for="(item, index) in form.singleMatterList"
          :key="item.matterId"
        >
          <van-field
            v-model="item.amount"
            :label="item.matterName"
            type="digit"
            placeholder="点击填写"
            :disabled="
              Boolean(
                ($route.query.contractId &&
                  (form.status == 3 || form.type == 4)) ||
                  $route.query.transferContractId
              )
            "
            :rules="[{ required: true, message: '请填写' + item.matterName }]"
          />

          <div class="after">元</div>

          <div class="after">
            <button
              class="sub"
              @click="subAmountS(index)"
              :disabled="
                Boolean(
                  ($route.query.contractId &&
                    (form.status == 3 || form.type == 4)) ||
                    $route.query.transferContractId
                )
              "
            ></button>
          </div>
        </div>

        <div class="field">
          周期性费用

          <span class="button-mini">
            <van-icon
              name="plus"
              @click="
                (item) => {
                  if (
                    !Boolean(
                      ($route.query.contractId &&
                        (form.status == 3 || form.type == 4)) ||
                        $route.query.transferContractId
                    )
                  ) {
                    showFeeP = true;

                    amountType = 0;
                  }
                }
              "
            />
          </span>
        </div>

        <div
          class="unit"
          v-for="(item, index) in form.periodMatterList"
          :key="item.matterId"
        >
          <van-field
            v-model="item.amount"
            :label="item.matterName"
            type="digit"
            placeholder="点击填写"
            :disabled="
              Boolean(
                ($route.query.contractId &&
                  (form.status == 3 || form.type == 4)) ||
                  $route.query.transferContractId
              )
            "
            :rules="[{ required: true, message: '请填写' + item.matterName }]"
          />

          <div class="after">元/月</div>

          <div class="after">
            <button
              class="sub"
              @click="subAmountP(index)"
              :disabled="
                Boolean(
                  ($route.query.contractId &&
                    (form.status == 3 || form.type == 4)) ||
                    $route.query.transferContractId
                )
              "
            ></button>
          </div>
        </div>
      </van-form>

      <div style="height: 1.2rem"></div>

      <div class="btn">
        <van-button round block type="primary" @click="active = 0;"
          >上一步</van-button
        >

        <van-button round block type="primary" @click="next2"
          >下一步</van-button
        >
      </div>
    </div>

    <!-- 第三步 -->

    <div v-if="active === 2" class="form3">
      <div v-for="item in assetsData" :key="item.no">
        <div class="title">
          <i class="iconfont iconbookmark"></i>

          {{ item.no === "Pub" ? "公区" : item.no }}&ensp;
        </div>

        <div class="assetsBody">
          <div
            v-for="assets in item.assets"
            :key="assets.assetsId"
            @click="lookAssets(assets)"
          >
            {{ assets.materialTypeName }}
          </div>
        </div>
      </div>

      <van-empty v-if="!assetsData.length" description="暂无资产" />

      <div style="height: 1.2rem"></div>

      <div class="btn">
        <van-button round block type="primary" @click="active = 1"
          >上一步</van-button
        >

        <van-button round block type="primary" @click="next3"
          >下一步</van-button
        >
      </div>
    </div>

    <!-- 第四步 -->

    <div v-if="active === 3" class="form4">
      <van-form ref="form4">
        <!-- 电度数 -->

        <div class="field van-cell--required">电度数</div>

        <div class="body">
          <div class="picCard" v-if="!existEle">
            <div class="text">电峰</div>

            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  electricMaxUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,

                      isImage: true,
                    },
                  ];

                  $refs.form4.resetValidation('electricMaxUrl');
                }
              "
              v-model="electricMaxUrl"
              :max-count="1"
            />

            <div class="text textBorder">
              <van-field
                type="number"
                name="electricMaxUrl"
                maxlength="11"
                v-model="form.electricMax"
                @input="
                  form.electricTotal = accAdd(
                    form.electricMin,

                    form.electricMax
                  )
                "
                border
                :placeholder="'当前:' + houseDegrees.lastElectricMax"
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(electricMaxUrl.length) || !imgUp;
                    },

                    message: '请上传电峰图',
                  },

                  { required: true, message: '请请输入电峰' },

                  {
                    validator: validNum0Decimal2,

                    message: '电峰必须为正数或0，且最多保留两位小数',
                  },
                ]"
              />
            </div>
          </div>

          <div class="picCard" v-if="!existEle">
            <div class="text">电谷</div>

            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  electricMinUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,

                      isImage: true,
                    },
                  ];

                  $refs.form4.resetValidation('electricMinUrl');
                }
              "
              v-model="electricMinUrl"
              :max-count="1"
            />

            <div class="text textBorder">
              <van-field
                type="number"
                name="electricMinUrl"
                maxlength="11"
                v-model="form.electricMin"
                @input="
                  form.electricTotal = accAdd(
                    form.electricMin,

                    form.electricMax
                  )
                "
                :placeholder="'当前:' + houseDegrees.lastElectricMin"
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(electricMinUrl.length) || !imgUp;
                    },

                    message: '请上传电谷图',
                  },

                  { required: true, message: '请输入电谷' },

                  {
                    validator: validNum0Decimal2,

                    message: '电谷必须为正数或0，且最多保留两位小数',
                  },
                ]"
              />
            </div>
          </div>

          <div class="picCard" v-if="!existEle">
            <div class="text">电总</div>

            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  electricTotalUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,

                      isImage: true,
                    },
                  ];

                  $refs.form4.resetValidation('electricTotalUrl');
                }
              "
              v-model="electricTotalUrl"
              :max-count="1"
            />

            <div class="text textBorder">
              <van-field
                type="number"
                name="electricTotalUrl"
                maxlength="11"
                v-model="form.electricTotal"
                :placeholder="'当前:' + houseDegrees.lastElectricTotal"
                :rules="[
                  { required: true, message: '请输入电总' },

                  {
                    validator: validNum0Decimal2,

                    message: '电总必须为正数或0，且最多保留两位小数',
                  },

                  {
                    validator: (item) => {
                      return !(
                        form.electricTotal < houseDegrees.lastElectricTotal && $store.state.user.companyId!='1939993008395112449'
                      );
                    },

                    message: `电总度数必须大于当前房源${houseDegrees.lastElectricTotal}`,
                  },

                  {
                    validator: (item) => {
                      return Boolean(electricTotalUrl.length) || !imgUp;
                    },

                    message: '请上传电总图',
                  },
                ]"
              />
            </div>
          </div>
          <div v-if="existEle" style="padding: 0.26667rem 0.42667rem">
            提示：该房源已安装智能电表，无需上传图片及度数
          </div>
        </div>

        <!-- 水度数 -->

        <div class="field van-cell--required">水度数</div>

        <div class="body">
          <div class="picCard" v-if="!existWater">
            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  waterUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,

                      isImage: true,
                    },
                  ];

                  $refs.form4.resetValidation('waterUrl');
                }
              "
              v-model="waterUrl"
              :max-count="1"
            />

            <div class="text textBorder">
              <van-field
                type="number"
                name="waterUrl"
                maxlength="11"
                v-model="form.water"
                :placeholder="'当前:' + houseDegrees.lastWater"
                :rules="[
                  { required: true, message: '请输入水度数' },

                  {
                    validator: validNum0Decimal2,

                    message: '水度数必须为正数或0，且最多保留两位小数',
                  },

                  {
                    validator: (item) => {
                      return !(form.water < houseDegrees.lastWater&& $store.state.user.companyId!='1939993008395112449');
                    },

                    message: `水度数必须大于当前房源${houseDegrees.lastWater}`,
                  },

                  {
                    validator: (item) => {
                      return Boolean(waterUrl.length) || !imgUp;
                    },

                    message: '请上传水图',
                  },
                ]"
              />
            </div>
          </div>
          <div v-if="existWater" style="padding: 0.26667rem 0.42667rem">
            提示：该房源已安装智能水表，无需上传图片及度数
          </div>
        </div>

        <!-- 燃气度数 -->

        <div class="field van-cell--required">燃气度数</div>

        <div class="body">
          <div class="picCard textBorder">
            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  gasUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,

                      isImage: true,
                    },
                  ];

                  $refs.form4.resetValidation('gasUrl');
                }
              "
              v-model="gasUrl"
              :max-count="1"
            />

            <div class="text textBorder">
              <van-field
                type="number"
                name="gasUrl"
                maxlength="11"
                v-model="form.gas"
                :placeholder="'当前:' + houseDegrees.lastGas"
                :rules="[
                  { required: true, message: '请输入燃气度数' },

                  {
                    validator: validNum0Decimal2,

                    message: '燃气度数必须为正数或0，且最多保留两位小数',
                  },

                  {
                    validator: (item) => {
                      return !(form.gas < houseDegrees.lastGas && $store.state.user.companyId!='1939993008395112449');
                    },

                    message: `燃气度数必须大于当前房源${houseDegrees.lastGas}`,
                  },

                  {
                    validator: (item) => {
                      return Boolean(gasUrl.length) || !imgUp;
                    },

                    message: '请上传燃气图',
                  },
                ]"
              />
            </div>
          </div>
        </div>

        <!-- 其他 -->

        <div class="field">其它</div>

        <div class="body body1">
          <van-uploader
            :before-read="beforeRead"
            :after-read="
              (item) => {
                otherUrl.pop();

                otherUrl.push({
                  url: upload_qiniu_addr + item.file.key,

                  isImage: true,
                });
              }
            "
            v-model="otherUrl"
            :max-count="9"
          />
        </div>
      </van-form>

      <div style="height: 1.2rem"></div>

      <div class="btn">
        <van-button round block type="primary" @click="active = 2"
          >上一步</van-button
        >

        <van-button
          round
          block
          type="primary"
          @click="next4"
          :loading="saveLoad"
          :disabled="saveLoad"
          >保存</van-button
        >
      </div>
    </div>

    <!-- 房源搜索 -->

    <transition name="van-slide-right">
      <div v-if="showHouse" class="search">
        <form action="/">
          <van-search
            v-model="searchValueHouse"
            shape="round"
            show-action
            placeholder="请输入房源地址搜索"
            @input="onSearchHouse"
            @search="onSearchHouse"
            @cancel="onCancel"
          />
        </form>

        <van-cell
          v-for="house in houseList"
          :key="house.id"
          :title="house.number + ' | ' + house.address"
          icon="wap-home-o"
          @click="changeHouse(house)"
        ></van-cell>

        <van-loading v-if="searchLoad" size="24" />

        <div v-else-if="searchValueHouse && !houseList.length">暂无数据</div>
      </div>
    </transition>

    <!-- 客户搜索 -->

    <transition name="van-slide-right">
      <div v-if="showCustomer" class="search">
        <form action="/">
          <van-search
            v-model="searchValueCustomer"
            shape="round"
            show-action
            placeholder="请输入手机号搜索"
            @input="onSearchCustomer"
            @search="onSearchCustomer"
            @cancel="onCancel"
          />
        </form>

        <van-cell
          v-for="customer in customerList"
          :key="customer.id"
          :title="customer.name + '-' + customer.phone"
          icon="user-o"
          @click="changeCustomer(customer)"
        ></van-cell>

        <van-loading v-if="searchLoad" size="24" />

        <div v-else-if="searchValueCustomer && !customerList.length">
          暂无数据
        </div>
      </div>
    </transition>

    <!-- 入住人搜索 -->
    <transition name="van-slide-right">
      <div v-if="showCheckPerson" class="search">
        <form action="/">
          <van-search
            v-model="searchValueCheckPerson"
            shape="round"
            show-action
            placeholder="请输入手机号搜索"
            @input="onSearchCheckPerson"
            @search="onSearchCheckPerson"
            @cancel="onCancel"
          />
        </form>

        <van-cell
          v-for="checkPerson in checkPersonList"
          :key="checkPerson.id"
          :title="checkPerson.name + '-' + checkPerson.phone"
          icon="user-o"
          @click="changeCheckPerson(checkPerson)"
        ></van-cell>

        <van-loading v-if="searchLoad" size="24" />

        <div v-else-if="searchValueCheckPerson && !checkPersonList.length">
          暂无数据
        </div>
      </div>
    </transition>
    <!-- 证件类型 -->

    <van-popup v-model="showIdType" position="bottom">
      <van-picker
        show-toolbar
        :columns="form.customerType == '1' ? idTypeList1 : ['社会信用代码']"
        @confirm="
          (item, index) => {
            form.customerType == '1'
              ? (form.idType = index / 1 + 1)
              : (form.idType = 6);

            showIdType = false;

            $refs.form1.resetValidation('idNo');
          }
        "
        @cancel="showIdType = false"
      />
    </van-popup>

    <!-- 紧急联系人关系 -->

    <van-popup v-model="showContact" position="bottom">
      <van-picker
        show-toolbar
        :columns="contactList"
        @confirm="
          (item, index) => {
            form.contactRelation = index / 1 + 1;

            showContact = false;
          }
        "
        @cancel="showContact = false"
      />
    </van-popup>

    <!-- 入住人证件类型 -->

    <van-popup v-model="showIdType1" position="bottom">
      <van-picker
        show-toolbar
        :columns="idTypeList1"
        @confirm="changePersonType"
        @cancel="showIdType1 = false"
      />
    </van-popup>

    <!-- 开始日期 -->

    <van-popup v-model="showStartDate" position="bottom">
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        @confirm="startDateConfirm"
        @cancel="showStartDate = false"
        :min-date="startRangeDate"
        :max-date="endRangeDate"
      />
    </van-popup>

    <!-- 支付方式 -->
 <!-- @confirm="
          (item, index) => {
            form.payMonth = item.payMonth;

            form.depositMonth = item.depositMonth;
  depositInputEnabled = item.depositInputEnabled;
       form.deposit= item.depositPrice;
       depositPrice = item.depositPrice;
            form.rental = item.price;
            form.activityRental = item.activityPrice;
            form.deposit = this.accMul(item.price, item.depositMonth);
            changeServiceFee();
            showPayType = false;
          }
        " -->
    <van-popup v-model="showPayType" position="bottom">
      <van-picker
        show-toolbar
        value-key="label"
        :columns="payTypeList"
       @confirm="onConfirm
         
        "
        @cancel="showPayType = false"
      />
    </van-popup>

    <!-- 费用 -->

    <van-popup v-model="showFeeS" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="matterListS"
        @confirm="addAmountS"
        @cancel="showFeeS = false"
      />
    </van-popup>

    <van-popup v-model="showFeeP" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="matterListP"
        @confirm="addAmountP"
        @cancel="showFeeP = false"
      />
    </van-popup>
    <!-- 活动列表 -->
    <van-popup v-model="showActivity" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="activityList"
        @confirm="
        (item,index)=>{
          changeActivity(item)
        }
        "
        @cancel="showActivity = false"
      />
    </van-popup>

    <!-- 资产详情 -->

    <van-dialog
      v-model="showAssets"
      title="资产详情"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
      :closeOnClickOverlay="true"
    >
      <van-cell title="名称" :value="asstesDetail.materialTypeName" />

      <van-cell title="品类" :value="asstesDetail.materialTypeParentName" />

      <van-cell title="规格" :value="asstesDetail.specification" />

      <van-cell title="品牌" :value="asstesDetail.brand" />

      <van-cell title="型号" :value="asstesDetail.model" />
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

import {
  validPhone,
  validEmail,
  validIdNo,
  validNum0,
  validNum,
  validNum0Decimal2,
  validNum100,
} from "@/utils/validate";

import {
  formatDate,
  getEndDate,
  getNdaysDate,
  accAdd,
  End,
  accMul,
  accSub,
} from "@/utils/index";

import request from "@/utils/request";
import {
  requestHouseList, //房源类型
  requestHouseType, //房间
  requestDesCustomerList, //搜索客户
  requestCheckPersonList, //搜索入住人
  requestContractCreate, //合约创建
  requestContractDetail, //合约详情
  requestSaveContractDetail, //暂存状态合约详情
  requestResignContractDetail, //重签
  requestCustomerDetail, //客户详情
  requestHouseDetailId, //房源详情
  requestRoomDetailID, //房间详情
  requestDestineContractDetail, //预订单详情
  requestSkuPrice, //sku套餐价格明细
  requestFContractDetail, //分散式业主合约详情
  requestJContractDetail, //集中式业主合约详情
  requestMatterZX, //费用项下拉
  requestExpensesContractS, //一次性费用
  requestExpensesContractP, //周期性费用
  requestQiniuToken, //七牛token
  requestAssetsDetail, //资产详情
  requestPropertyFee, //物业费
  requestLease, //根据开始结束日期计算租期
  requestParameterRules, //获取预缴费规则
  requestDepositRules, //获取托管规则
  requestHouseWaterExist,
  requestHouseElectronicExist,
  requestHouseWaterIsRight,
  requestHouseElectronicIsRight,
  requestHouseSettlement, //校验房源当天有没有结算水电费
  requestGoSettlement,
  requestHouseDeviceIsOnOff,
  requestContractActivityList,
} from "@/api";
import moment from "moment";
import { imgUp, imgMaskUrl, isAddTextMask } from "@/common/js/constant.js";

import { compress, compressAccurately } from "image-conversion";

export default {
  name: "contractAdd",

  data() {
    return {
       imgMaskUrl ,
            isAddTextMask,
      imgUp: imgUp,

      active: 0,

      activeMax: 0, //用户已经走到那一步（之前的步骤可以随意跳转）

      isZancun: true,

      nextDisabled: false,
      advanceIsEmpty: null,
      advancePrice: null,
      prepayment: {
        isSharingEmpty: null,
        isWholeEmpty: null,
        isUpdate: null,
        sharingPrice: null,
        wholePrice: null,
        basePrice: null,
      },
      ownerType: "",
       prevContractData:"",
      eleWaterMeterShow: "",
      depositInputEnabled:false,
      form: {
        //第一步

        contractId: "",

        operationNo: 1,

        //step1

        communityId: "", //小区id

        houseId: "", //房源id

        roomId: "", //房间id

        rentType: "", //出租方式
        acreage: "",
        customerId: "", //租客id

        priceSkuId: "", //skuid

        customerPhone: "", //租客电话

        customerName: "", //租客姓名

        customerType: 1,
        autoPowerOff: 0, //是否断电
        orgNo: "",

        orgName: "",

        idType: "", //证件类型

        idNo: "", //证件号码

        email: "", //邮箱

        company: "", //工作单位

        position: "", //职位

        contactName: "", //紧急联系人姓名

        contactRelation: "", //紧急联系人关系

        contactPhone: "", //紧急联系人电话

        transferId: "", //派单id

        persons: 1, //入住人数
        checkPersonPhone: "",
        customerPersonList: [
          {
            name: "",

            phone: "",

            idType: "",

            idCard: "",

            frontCertificateUrl: "",

            backCertificateUrl: "",
          },
        ],
         
        //step2
startDateAfterDays:"",
        startRangeDate: "", //开始日期的范围start

        endRangeDate: "", //开始日期的范围end

        startDate: "", //开始日期
        activityId: "",
        leaseMonth: "", //租期月

        leaseDay: "", //租期日

        endDate: "", //结束日期

        payMonth: "", //付几

        depositMonth: "", //押几

        rental: "", //租金
        activityRental:"",
        deposit: "", //押金

        amount: "", //定金

        advanceFee: "", //水电燃预缴费

        serviceFee: "", //服务费
        serviceFeeRate: "",
        condoFee: "", //物业费

        remark: "", //备注

        propertyContractId: "", //业主合约id

        singleMatterList: [], //一次性费用

        periodMatterList: [], //周期性费用

        //step3

        //step4

        electricTotalUrl: "", //电总图

        electricMaxUrl: "", //电峰图

        electricMinUrl: "", //电谷图

        electricTotal: "", //电总

        electricMax: "", //电峰

        electricMin: "", //电谷

        waterUrl: "", //水图

        water: "", //水

        gasUrl: "", //燃气图

        gas: "", //燃气

        contactUrl: "", //合约

        otherUrl: "", //其它
      },

      //step1

      //搜索房源

      // idTypeList1: ["身份证", "港澳台通行证", "护照"],
      idTypeList1: [
        {
          value: "1",
          text: "身份证",
        },
        {
          value: "2",
          text: "港澳通行证",
        },
        {
          value: "3",
          text: "护照",
        },
        {
          value: "7",
          text: "台湾通行证",
        },
      ],
      showHouse: false,

      houseNow: {},

      searchValueHouse: "",

      isCustomerTypeChange: true, //只有点击时才触发

      houseList: [],

      ifChangeHouse: false,

      currentDate: new Date(),

      rentTypeNow: "",

      rentTypeList: [],

      disable: {
        house: false,

        customer: false,

        room: false,
      },

      //客户搜索

      showCustomer: false,

      customerNow: {},

      searchValueCustomer: "",

      customerList: [], //搜索客户

      searchLoad: false,

      showIdType: false,

      showContact: false,

      personIndex: 0, //当前入住人下标

      showIdType1: false,

      contractorFront: [], //签约人身份证正面

      contractorBack: [], //签约人身份证反面

      businessLicense: [], //签约人营业执照

      cardList: [
        {
          prevIdCard: [],

          backIdCard: [],
        },
      ], //入住人

      showCheckPerson: false,
      searchValueCheckPerson: "",
      checkPersonList: [],
      checkPersonIndex: 0,
      //搜索入住人
      //step2

      oldContract: {
        endDate: "",
      },

      propertyContract: {
        quitDate: "",

        number: "",
      }, //业主信息

      showStartDate: false,

      showPayType: false,

      payTypeList: [], //支付方式下拉
      // 活动相关配置
      activityList: [],
      showActivity: false,
      activity:"",
      startRangeDate: new Date(2010, 0, 1),

      endRangeDate: new Date(2031, 12, 31),

      leaseDayValid: "",

      validStartDate: true,

      showFeeS: false,

      matterListS: [],

      showFeeP: false,

      matterListP: [],

      amountType: 1, //一次性or周期性

      //step3

      assetsData: [],

      asstesDetail: {},

      showAssets: false,

      //step4
      showWaterModel: "",
      showElectronicModel: "",
      waterSubmit: "",
      ElectronicSubmit: "",
      houseDegrees: {}, //当前房源水电燃度数

      saveLoad: false,

      qiniuData: {
        key: "",

        token: "",
      },

      electricTotalUrl: [], //电总

      electricMaxUrl: [], //电峰

      electricMinUrl: [], //电谷

      waterUrl: [], //水

      gasUrl: [], //燃气

      otherUrl: [], //其他
    };
  },

  computed: {
    ...mapState([
      "idTypeList",

      "destineList",

      "contractList",

      "contactList",

      "upload_qiniu_addr",
    ]),
    acreage() {
      let rentTypeNow = this.rentTypeList.find((d) => {
        return d.roomNo == this.rentTypeNow;
      });

      if (rentTypeNow) {
        return rentTypeNow.rentType < 2
          ? rentTypeNow.acreage
          : rentTypeNow.totalAcreage;
      }
    },
  },

  created() {
    console.log(this.$store.state.user)
    this.endRangeDate = new Date(getNdaysDate(formatDate(new Date()), this.startDateAfterDays));

    //客户列表进（客户签约）

    if (this.$route.query.customerId) {
      this.getCustomerDetail(this.$route.query.customerId);
    }

    //房源列表进（新合约）

    if (this.$route.query.houseId) {
      //整租

      this.getHouseDetail(this.$route.query.houseId);
    }

    if (this.$route.query.roomId) {
      //合租

      this.getRoomDetail(this.$route.query.roomId);
    }

    //预订单（预订签约）

    if (this.$route.query.destineContractId) {
      this.getDestineContractDetail(this.$route.query.destineContractId);
    }

    //（修改合约/继续走流程

    if (this.$route.query.contractId) {
      this.getDetail(this.$route.query.contractId);

      this.activeMax = 3;

      this.isZancun = false;
    }

    //（重签）

    if (this.$route.query.oldContractId) {
      this.getResignDetail(this.$route.query.oldContractId);

      this.isZancun = false;
    }

    //（续签）

    if (this.$route.query.prevContractId) {
      this.getContinueDetail(this.$route.query.prevContractId);

      this.isZancun = false;
    }

    //（转租）

    if (this.$route.query.transferContractId) {
      this.getTransferDetail(this.$route.query.transferContractId);

      this.isZancun = false;
    }

    //（换房）

    if (this.$route.query.changeHouseContractId) {
      this.getChangeHouseDetail(this.$route.query.changeHouseContractId);

      this.isZancun = false;
    }
    // 请求预缴费规则
    this.getParmeterRules();
     this.getStartDays()
    this.getDepositRules();
    // this.getMatter();
  },

  mounted() {
    this.getQiniuToken();
  },

  methods: {
    //详情赋值

    toValue(res, param) {
      console.log("复制")
      //入住人
      if (
        res.data.customerPersonListNew &&
        res.data.customerPersonListNew.length > 0
      ) {
        this.cardList = []; //入住人

        res.data.customerPersonListNew.forEach((d) => {
          this.cardList.push({
            prevIdCard: [{ url: d.frontCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`, isImage: true }],

            backIdCard: [{ url: d.backCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`, isImage: true }],
          });
        });
      }

      //第三步资产

      this.assetsData = res.data.contractAssetsVOList
        ? res.data.contractAssetsVOList
        : [];

      //图片--
      // 重签、修改、换房、续签获取最新实名信息
      if (
        param.isResign ||
        param.isChange ||
        param.isContinue ||
        param.isChangeHouse
      ) {
        this.contractorFront = res.data.customer.frontCertificateUrl
          ? [
              {
                url: res.data.customer.frontCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`,

                isImage: true,
              },
            ]
          : []; //签约人身份证正面

        this.contractorBack = res.data.customer.backCertificateUrl
          ? [
              {
                url: res.data.customer.backCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`,

                isImage: true,
              },
            ]
          : []; //签约人身份证反面

        this.form.contractorFront = res.data.customer.frontCertificateUrl; //签约人正面

        this.form.contractorBack = res.data.customer.backCertificateUrl; //签约人反面
      } else {
        this.contractorFront = res.data.contractImage.contractorFront
          ? [
              {
                url: res.data.contractImage.contractorFront + `${isAddTextMask?imgMaskUrl:''}`,

                isImage: true,
              },
            ]
          : []; //签约人身份证正面

        this.contractorBack = res.data.contractImage.contractorBack
          ? [
              {
                url: res.data.contractImage.contractorBack + `${isAddTextMask?imgMaskUrl:''}`,

                isImage: true,
              },
            ]
          : []; //签约人身份证反面

        this.form.contractorFront = res.data.contractImage.contractorFront; //签约人正面

        this.form.contractorBack = res.data.contractImage.contractorBack; //签约人反面
      }

      if (res.data.contractImage) {
        this.businessLicense = res.data.contractImage.businessLicense
          ? [
              {
                url: res.data.contractImage.businessLicense,

                isImage: true,
              },
            ]
          : []; //签约人营业执照

        this.form.businessLicense = res.data.contractImage.businessLicense; //营业执照

        this.electricTotalUrl = res.data.contractImage.electricTotal
          ? [
              {
                url: res.data.contractImage.electricTotal,

                isImage: true,
              },
            ]
          : []; //电总

        this.electricMaxUrl = res.data.contractImage.electricMax
          ? [
              {
                url: res.data.contractImage.electricMax,

                isImage: true,
              },
            ]
          : []; //电峰

        this.electricMinUrl = res.data.contractImage.electricMin
          ? [
              {
                url: res.data.contractImage.electricMin,

                isImage: true,
              },
            ]
          : []; //电谷

        this.waterUrl = res.data.contractImage.water
          ? [{ url: res.data.contractImage.water, isImage: true }]
          : []; //水

        this.gasUrl = res.data.contractImage.gas
          ? [{ url: res.data.contractImage.gas, isImage: true }]
          : []; //燃气

        this.otherUrl = []; //其他

        if (res.data.contractImage.other) {
          let otherUrl = res.data.contractImage.other.split(";");

          otherUrl.forEach((d) => {
            this.otherUrl.push({ url: d, isImage: true });
          });
        }
      }

      //赋值

      this.form.id = res.data.id;
      this.existEle = res.data.existEle;
      this.existWater = res.data.existWater;
      this.form.prevId = res.data.contract.prevId;

      this.form.status = res.data.contract.status;

      this.form.destineId = res.data.destineContract
        ? res.data.destineContract.id
        : ""; //预订单id

      this.form.isResign = param.isResign; //重签1:是

      this.form.type = res.data.contract.type; //1：新签，2：续签，3：换房，4：转租;

      this.form.priceSkuId = res.data.house ? res.data.house.priceSkuId : ""; //sku

      this.form.communityContractId = res.data.house.communityContractId; //集中式收房合约id

      this.form.communityType = res.data.house.type; //收房合约类型 集中式or分散式

      //step1

      this.form.houseId = res.data.house.id; //房源id

      this.form.roomId = res.data.room ? res.data.room.id : ""; //房间id

      this.form.communityId = res.data.community ? res.data.community.id : ""; //小区id

      this.form.rentType = res.data.contract.rentType; //出租类型

      this.form.customerPhone = res.data.customer.phone; //租客电话

      this.form.customerName = res.data.customer.name; //租客姓名

      this.form.customerId = res.data.customer.id; //租客id

      this.form.idType = res.data.customer.idType; //证件类型

      this.form.customerType = res.data.contract.customerType; //客户类型

      this.form.orgNo = res.data.contract.orgNo; //企业号码

      this.form.orgName = res.data.contract.orgName; //企业名称

      this.form.idNo = res.data.customer.idNo; //证件号码

      this.form.email = res.data.customer.email; //邮箱

      this.form.company = res.data.customer.company; //工作单位

      this.form.position = res.data.customer.position; //职位

      this.form.contactName = res.data.contract.contactName; //紧急联系人姓名

      this.form.contactRelation = res.data.contract.contactRelation; //紧急联系人关系

      this.form.contactPhone = res.data.contract.contactPhone; //紧急联系人电话

      this.form.transferId = res.data.customer.transferId; //派单人id

      this.form.persons = (res.data.customerPersonListNew || []).length; //入住人数

      this.form.customerPersonList = res.data.customerPersonListNew
        ? res.data.customerPersonListNew
        : []; //入住人

      //step2

      this.form.startRangeDate = res.data.contract.startRangeDate; //开始日期的范围start

      this.form.endRangeDate = res.data.contract.endRangeDate; //开始日期的范围end

      this.form.startDate = res.data.contract.startDate; //开始日期
   this.form.activityId = res.data.contract.activityId||'';
     this.form.activity = res.data.contract.activity
      this.form.leaseMonth = res.data.contract.leaseMonth
        ? res.data.contract.leaseMonth
        : ""; //租期月

      this.form.leaseDay = res.data.contract.leaseDay
        ? res.data.contract.leaseDay
        : ""; //租期日

      this.form.endDate = res.data.contract.endDate; //结束日期

      this.form.payMonth = res.data.contract.payMonth; //付几
      console.log("fuzhi", this.form.payMonth)
      this.form.depositMonth = res.data.contract.depositMonth; //押几

      this.form.rental = res.data.contract.rental; //租金
       this.form.activityRental = res.data.contract.activityRental;
      this.form.deposit = res.data.contract.deposit; //押金

      this.form.propertyContractId = res.data.propertyContract
        ? res.data.propertyContract.id
        : ""; //业主合约id

      this.form.amount = res.data.destineContract
        ? res.data.destineContract.amount
        : ""; //定金

      this.form.advanceFee = res.data.contract.advanceFee; //水电燃预缴费

      this.form.serviceFee = res.data.contract.serviceFee; //服务费
      this.form.autoPowerOff = res.data.contract.autoPowerOff; //是否断电
      this.form.serviceFeeRate = this.serviceFeeRate; //服务费
      this.form.condoFee = res.data.contract.condoFee; //物业费

      this.form.singleMatterList = res.data.singleMatterList
        ? res.data.singleMatterList
        : []; //一次性费用

      this.form.periodMatterList = res.data.periodMatterList
        ? res.data.periodMatterList
        : []; //周期性费用

      this.form.remark = res.data.contract.remark;
      if (this.form.type != 1 || this.$route.query.oldContractId) {
        this.ownerType = res.data.tenantType;
      }
      //step4

      this.form.electricTotal = res.data.contract.electricTotal; //电总

      this.form.electricMax = res.data.contract.electricMax; //电峰

      this.form.electricMin = res.data.contract.electricMin; //电谷

      this.form.water = res.data.contract.water; //水

      this.form.gas = res.data.contract.gas; //燃气

      this.form.electricTotalUrl = res.data.contractImage
        ? res.data.contractImage.electricTotal
        : ""; //电总图

      this.form.electricMaxUrl = res.data.contractImage
        ? res.data.contractImage.electricMax
        : ""; //电峰图

      this.form.electricMinUrl = res.data.contractImage
        ? res.data.contractImage.electricMin
        : ""; //电谷图

      this.form.waterUrl = res.data.contractImage
        ? res.data.contractImage.water
        : ""; //水图

      this.form.gasUrl = res.data.contractImage
        ? res.data.contractImage.gas
        : ""; //燃气图

      this.form.otherUrl = res.data.contractImage
        ? res.data.contractImage.otherUrl
        : ""; //其它图

      //修改（新签），续签，重签，换房需重新获取物业费

      // if (

      //     (this.$route.query.contractId && this.form.type == 1) ||

      //     this.$route.query.prevContractId ||

      //     this.$route.query.oldContractId

      // ) {

      //     this.getPropertyFee();

      // }

      //水电燃度数

      this.houseDegrees = {
        lastElectricMax: res.data.house.lastElectricMax / 1,

        lastElectricMin: res.data.house.lastElectricMin / 1,

        lastElectricTotal: res.data.house.lastElectricTotal / 1,

        lastGas: res.data.house.lastGas / 1,

        lastWater: res.data.house.lastWater / 1,
      };
      if (!this.$route.query.changeHouseContractId) {
        this.getHouseType();
        this.rentTypeNow = this.form.rentType == "2" ? null : res.data.room.no.slice(0,1);
      }

      // //转租获取支付方式

      // requestSkuPrice({

      //   priceSkuId: this.form.priceSkuId,

      //   lease: this.form.leaseMonth / 1 ? this.form.leaseMonth : 1,

      //   houseId: this.form.houseId,

      //   roomId: this.form.roomId,

      //   rentType: this.form.rentType

      // }).then(resData => {

      //   let payTypeList = [];

      //   resData.data.forEach(d => {

      //     payTypeList.push({

      //       label:

      //         d.payMonth == 999

      //           ? "全额付"

      //           : "押" + d.payMonth + "付" + d.depositMonth,

      //       payMonth: d.payMonth,

      //       depositMonth: d.depositMonth,

      //       price: d.price

      //     });

      //   });

      //   this.payTypeList = payTypeList;

      // });
      
    },

    //清空合约信息

    resetValue() {
      this.cardList = [
        {
          prevIdCard: [],

          backIdCard: [],
        },
      ]; //入住人

      //第三步资产

      this.assetsData = [];

      //图片--

      this.contractorFront = []; //签约人身份证正面

      this.contractorBack = []; //签约人身份证反面

      this.businessLicense = []; //签约人营业执照

      this.electricTotalUrl = []; //电总

      this.electricMaxUrl = []; //电峰

      this.electricMinUrl = []; //电谷

      this.waterUrl = []; //水

      this.gasUrl = []; //燃气

      this.otherUrl = []; //其他

      this.form.id = "";

      this.form.prevId = "";

      this.form.status = "";

      this.form.destineId = ""; //预订单id

      this.form.isResign = ""; //重签1:是

      this.form.type = ""; //1：新签，2：续签，3：换房，4：转租;

      this.customerNow = {};

      this.form.customerId = "";

      this.form.customerPhone = "";

      this.form.customerName = "";

      this.form.customerType = 1;
      this.form.autoPowerOff = ""; //是否断电
      this.form.orgNo = "";

      this.form.orgName = "";

      this.form.idType = 1;

      this.form.idNo = "";

      this.form.email = "";

      this.form.company = "";

      this.form.position = "";

      this.form.contactName = "";

      this.form.contactRelation = "";

      this.form.contactPhone = "";

      this.form.persons = 1;

      this.contractorFront = [];

      this.form.contractorFront = "";

      this.contractorBack = [];

      this.form.contractorBack = "";

      this.form.customerPersonList = [
        {
          name: "",

          phone: "",
          id: "",
          idType: "",

          idCard: "",

          frontCertificateUrl: "",

          backCertificateUrl: "",
        },
      ];

      //step2

      this.form.startRangeDate = ""; //开始日期的范围start

      this.form.endRangeDate = ""; //开始日期的范围end

      this.form.startDate = ""; //开始日期
       this.form.activityId = ""  
      this.form.leaseMonth = ""; //租期月

      this.form.leaseDay = ""; //租期日

      this.form.endDate = ""; //结束日期

      this.form.payMonth = ""; //付几

      this.form.depositMonth = ""; //押几

      this.form.rental = ""; //租金

      this.form.deposit = ""; //押金
  this.form.activityRental = "";
      this.form.amount = ""; //定金

      this.form.advanceFee = ""; //水电燃预缴费

      this.form.serviceFee = ""; //服务费

      this.form.condoFee = ""; //物业费

      this.form.singleMatterList = []; //一次性费用

      this.form.periodMatterList = []; //周期性费用

      this.form.remark = "";

      //step4

      this.form.electricTotal = ""; //电总

      this.form.electricMax = ""; //电峰

      this.form.electricMin = ""; //电谷

      this.form.water = ""; //水

      this.form.gas = ""; //燃气

      this.form.electricTotalUrl = ""; //电总图

      this.form.electricMaxUrl = ""; //电峰图

      this.form.electricMinUrl = ""; //电谷图

      this.form.waterUrl = ""; //水图

      this.form.gasUrl = ""; //燃气图

      this.form.otherUrl = ""; //其它图
    },

    //获取修改合约详情

    getDetail(id) {
      requestContractDetail(id).then((res) => {
        this.houseNow = res.data.house;

        this.disable.house = Boolean(
          this.$route.query.houseId ||
            this.$route.query.roomId ||
            this.$route.query.destineContractId ||
            res.data.contract.status == 3 ||
            res.data.destineContract ||
            res.data.contract.type == 2 ||
            res.data.contract.type == 4
        );

        this.disable.room = Boolean(
          this.$route.query.roomId ||
            this.$route.query.destineContractId ||
            res.data.contract.status == 3 ||
            res.data.destineContract ||
            res.data.contract.type == 2 ||
            res.data.contract.type == 4
        );

        this.disable.customer = Boolean(
          this.$route.query.customerId ||
            this.$route.query.destineContractId ||
            res.data.contract.status == 3 ||
            res.data.destineContract ||
            res.data.contract.type == 2 ||
            res.data.contract.type == 3
        );

        if (
          !res.data.contract.destineId &&
          res.data.contract.type == 1 &&
          (!res.data.contract.status || res.data.contract.status == 1)
        ) {
          res.data.contract.endRangeDate =
            getNdaysDate(formatDate(new Date()), this.startDateAfterDays) + " 00:00:00";
        }

        //请求支付方式

        // let param = {
        //   priceSkuId: res.data.house.priceSkuId,

        //   lease: res.data.contract.leaseMonth / 1 || 1,

        //   houseId: res.data.house.id,

        //   roomId: res.data.room ? res.data.room.id : "",

        //   rentType: res.data.contract.rentType,
        // };

        // this.getSku(param);

        requestHouseType(this.houseNow.id, 2).then((resData) => {
          this.rentTypeList = resData.data;

          this.rentTypeNow =
            res.data.contract.rentType == 1 ? res.data.room.no.slice(0,1) : null;

          let rentTypeNow = this.rentTypeList.find((d) => {
            return d.roomNo == this.rentTypeNow;
          });
      
          this.eleWaterMeterShow = rentTypeNow.eleWaterMeterShow;
        });

        this.toValue(res, { isChange: 1 });
      });
    },

    //获取暂存或保存状态合约

    getSaveContractDetail() {
      let param = {
        houseId: this.form.houseId,

        roomId: this.form.roomId,

        customerId: this.form.customerId,

        rentType: this.form.rentType,
      };

      if (
        !param.houseId ||
        !param.customerId ||
        !param.rentType ||
        this.$route.query.oldContractId ||
        this.$route.query.prevContractId ||
        this.$route.query.transferContractId ||
        this.$route.query.changeHouseContractId
      ) {
        return;
      }

      this.nextDisabled = true;

      requestSaveContractDetail(param).then((res) => {
        this.nextDisabled = false;

        if (res.data) {
          if (this.form.id != res.data.id && res.data.contract.status) {
            this.activeMax = 0;

            this.nextDisabled = true;

            this.$dialog.alert({
              message: "该合约已存在（" + res.data.contract.number + "）",
            });
          }

          (res.data.id = this.$route.query.contractId
            ? this.form.id
            : res.data.id),
            this.toValue(res, { isChange: 1});

          this.getHouseType();
        } else {
          this.form.advanceFee =
            this.form.rentType == 1
              ? this.prepayment.sharingPrice
              : this.prepayment.wholePrice; //水电燃预缴费
        }
      });
    },
    getHouseType() {

      requestHouseType(this.form.houseId, 2).then((res) => {
        this.rentTypeList = res.data;
        let rentTypeNow = this.rentTypeList.find((d) => {
          return d.roomNo == this.rentTypeNow;
        });
        console.log(rentTypeNow);
        
        this.eleWaterMeterShow = rentTypeNow.eleWaterMeterShow;

        console.log(this.form.deposit);
      });
    },
    //获取重签的老合约

    getResignDetail(id) {
      requestResignContractDetail(id).then((res) => {
        this.houseNow = res.data.house;
        res.data.contract.advanceFee = "";
        this.ifChangeHouse = true;
        requestHouseType(this.houseNow.id, 2).then((resData) => {
          this.rentTypeList = resData.data;

          this.rentTypeNow =
            res.data.contract.rentType == 1 ? res.data.room.no.slice(0,1) : null;
        });
         
        this.toValue(res, { isResign: 1 });

        this.getSku({
          priceSkuId: res.data.house.priceSkuId,

          lease: res.data.contract.leaseMonth / 1 || 1,

          houseId: res.data.house.id,

          roomId: res.data.room ? res.data.room.id : "",

          rentType: res.data.contract.rentType,
        });

        this.disable.customer = true;

        this.disable.house = true;

        this.disable.room = true;
      });
    },

    //获取续签的老合约

    getContinueDetail(id) {
      console.log("获取续签的老合约");
      requestContractDetail(id).then(async (res) => {
         this.prevContractData =  this._.cloneDeep(res.data);
        this.houseNow = res.data.house;

        res.data.contract.startDate =
          getNdaysDate(res.data.contract.endDate, 1) + " 00:00:00";

        res.data.contract.prevId = res.data.id;

        res.data.id = "";

        res.data.contract.type = "2";

        res.data.destineContract = "";
        res.data.contract.autoPowerOff = "";
        res.data.contract.leaseMonth = ""; //租期月

        res.data.contract.leaseDay = ""; //租期日

        res.data.contract.endDate = ""; //结束日期
        res.data.contract.activityId = ""; //活动id
        res.data.contract.payMonth = ""; //付几

        res.data.contract.depositMonth = ""; //押几

        res.data.contract.rental = ""; //租金
       res.data.contract.activityRental = "";
        res.data.contract.deposit = ""; //押金

        res.data.contract.advanceFee = "";

        this.ifChangeHouse = true;
        res.data.contract.autoPowerOff = ""; // 是否断电
        res.data.contract.serviceFee = ""; //服务费

        res.data.contract.condoFee = await this.getPropertyFeeAwait(
          res.data.house.id,

          res.data.rentType
        ); //物业费

        res.data.contract.electricTotal = ""; //电总

        res.data.contract.electricMax = ""; //电峰

        res.data.contract.electricMin = ""; //电谷

        res.data.contract.water = ""; //水

        res.data.contract.gas = ""; //燃气

        if (res.data.contractImage) {
          res.data.contractImage.electricTotal = ""; //电总图

          res.data.contractImage.electricMax = ""; //电峰图

          res.data.contractImage.electricMin = ""; //电谷图

          res.data.contractImage.water = ""; //水图

          res.data.contractImage.gas = ""; //燃气图
        }

        this.disable.customer = true;

        this.disable.house = true;

        this.disable.room = true;

        this.rentTypeNow =
          res.data.contract.rentType == 1 ? res.data.room.no.slice(0,1) : null;
 
        requestHouseType(this.houseNow.id, 2).then((resData) => {
          this.rentTypeList = resData.data;
        });

        this.toValue(res, { isContinue: 1 });
      });
    },

    //获取转租的老合约

    getTransferDetail(id) {
      requestContractDetail(id).then((res) => {
        this.houseNow = res.data.house;

        res.data.contract.prevId = res.data.id;

        res.data.id = ""; //

        res.data.contract.type = "4";

        res.data.contract.persons = 1; //入住人数
        res.data.contract.autoPowerOff = "";
        res.data.contract.leaseMonth = 0;

        res.data.contract.leaseDay = 0;

        res.data.destineContract = "";

        res.data.customer = {};

        res.data.customerPersonList = [
          {
            name: "",

            phone: "",

            idType: "",

            idCard: "",

            frontCertificateUrl: "",

            backCertificateUrl: "",
          },
        ];
        res.data.contract.advanceFee = "";
        res.data.contract.autoPowerOff = ""; // 是否断电
        this.ifChangeHouse = true;
        res.data.contract.electricTotal = ""; //电总

        res.data.contract.electricMax = ""; //电峰

        res.data.contract.electricMin = ""; //电谷

        res.data.contract.water = ""; //水

        res.data.contract.gas = ""; //燃气

        if (res.data.contractImage) {
          res.data.contractImage.contractorFront = ""; //签约人正面

          res.data.contractImage.contractorBack = ""; //签约人反面

          res.data.contractImage.businessLicense = ""; //企业照片

          res.data.contractImage.personImageList = ""; //入住人

          res.data.contractImage.electricTotal = ""; //电总图

          res.data.contractImage.electricMax = ""; //电峰图

          res.data.contractImage.electricMin = ""; //电谷图

          res.data.contractImage.water = ""; //水图

          res.data.contractImage.gas = ""; //燃气图
        }

        res.data.contract.startRangeDate = formatDate(new Date()) + " 00:00:00"; //

        let timeAfter3 = getNdaysDate(new Date(), 3) + " 00:00:00";

        res.data.contract.endRangeDate =
          res.data.contract.endDate < timeAfter3
            ? getNdaysDate(res.data.contract.endDate, -1) + " 00:00:00"
            : timeAfter3; //

        res.data.contract.startDate = "";
        res.data.contractImage.other = "";
        // getNdaysDate(formatDate(new Date()), 1) + " 00:00:00"; //开始时间默认当前时间加一天

        //房间

        requestHouseType(this.houseNow.id, 2).then((resData) => {
          this.rentTypeList = resData.data;

          this.rentTypeNow =
            res.data.contract.rentType == 1 ? res.data.room.no.slice(0,1) : null;
        });

        //计算租期

        // requestLease({

        //     startDate: res.data.contract.startDate.slice(0, 10),

        //     endDate: res.data.contract.endDate.slice(0, 10)

        // }).then(resData => {

        //     // debugger;

        //     res.data.contract.leaseMonth = resData.data.months;

        //     res.data.contract.leaseDay = resData.data.days;

        //     this.toValue(res, { isTransfer: 1 });

        // });

        this.toValue(res, { isTransfer: 1 });

        this.disable.house = true;

        this.disable.room = true;
      });
    },

    //获取换房的老合约

    getChangeHouseDetail(id) {
      requestContractDetail(id).then((res) => {
        res.data.contract.prevId = res.data.id;

        res.data.id = ""; //

        res.data.contract.type = "3";

        res.data.contract.rentType = "";

        res.data.contract.leaseMonth = 0;
        res.data.contract.autoPowerOff = "";
        res.data.contract.leaseDay = 0;

        res.data.contract.payMonth = "";

        res.data.contract.depositMonth = "";

        res.data.destineContract = "";

        res.data.contract.startDate = "";

        res.data.contract.rental = ""; //租金
      res.data.contract.activityRental = "";
        res.data.contract.deposit = ""; //押金
    res.data.contract.activityId = ""
        res.data.contract.advanceFee = ""; //水电燃预缴费
        this.ifChangeHouse = true;
        res.data.contract.autoPowerOff = ""; // 是否断电
        res.data.contract.serviceFee = ""; //服务费

        res.data.contract.condoFee = ""; //物业费

        res.data.singleMatterList = [];

        res.data.periodMatterList = [];

        res.data.contract.electricTotal = ""; //电总

        res.data.contract.electricMax = ""; //电峰

        res.data.contract.electricMin = ""; //电谷

        res.data.contract.water = ""; //水

        res.data.contract.gas = ""; //燃气

        if (res.data.contractImage) {
          res.data.contractImage.businessLicense = ""; //企业照片

          res.data.contractImage.electricTotal = ""; //电总图

          res.data.contractImage.electricMax = ""; //电峰图

          res.data.contractImage.electricMin = ""; //电谷图

          res.data.contractImage.water = ""; //水图

          res.data.contractImage.gas = ""; //燃气图
        }

        this.oldContract.endDate = res.data.contract.endDate;

        res.data.house.id = "";

        res.data.contract.startRangeDate = formatDate(new Date()) + " 00:00:00"; //

        let timeAfter3 = getNdaysDate(new Date(), 3) + " 00:00:00";

        res.data.contract.endRangeDate =
          res.data.contract.endDate < timeAfter3
            ? getNdaysDate(res.data.contract.endDate, -1) + " 00:00:00"
            : timeAfter3; //

        res.data.contract.startDate = ""; //开始时间默认当前时间加一天

        //计算租期

        // let param = {

        //     startDate: res.data.contract.startDate.slice(0, 10),

        //     endDate: res.data.contract.endDate.slice(0, 10)

        // };

        // requestLease(param).then(resData => {

        //     // debugger;

        //     res.data.contract.leaseMonth = resData.data.months;

        //     res.data.contract.leaseDay = resData.data.days;

        // });

        this.toValue(res, { isChangeHouse: 1 });

        this.disable.customer = true;
      });
    },

    //客户详情

    getCustomerDetail(id) {
      requestCustomerDetail(id).then((res) => {
        this.disable.customer = true;

        this.form.type = "1"; //1：新签，2：续签，3：换房，4：转租

        this.form.customerId = res.data.id; //租客id

        this.form.customerPhone = res.data.phone; //租客电话

        this.form.customerName = res.data.name; //租客姓名

        this.form.customerType = res.data.customerType || 1; //证件类型

        this.form.orgNo = res.data.orgNo; //

        this.form.orgName = res.data.orgName; //

        this.form.idType = res.data.idType; //

        this.form.idNo = res.data.idNo; //证件号码

        this.form.contactName = res.data.contactName; //紧急联系人姓名

        this.form.contactRelation = res.data.contactRelation; //紧急联系人关系

        this.form.contactPhone = res.data.contactPhone; //紧急联系人电话

        this.contractorFront = [
          {
            url: res.data.frontCertificateUrl  + `${isAddTextMask?imgMaskUrl:''}`,

            isImage: true,
          },
        ];

        this.form.contractorFront = res.data.frontCertificateUrl;

        this.contractorBack = [
          {
            url: res.data.backCertificateUrl,

            isImage: true,
          },
        ];

        this.form.contractorBack = res.data.backCertificateUrl;

        this.form.customerPersonList = [];

        this.cardList = [];

        for (let i = 0; i < (this.form.persons || 1); i++) {
          this.form.customerPersonList.push({
            name: "",

            phone: "",

            idType: "",
            id: "",
            idCard: "",

            frontCertificateUrl: "",

            backCertificateUrl: "",
          });

          this.cardList.push({
            prevIdCard: [],

            backIdCard: [],
          });
        }

        this.form.customerPersonList[0].name = res.data.name;

        this.form.customerPersonList[0].phone = res.data.phone;

        this.form.customerPersonList[0].idType = res.data.idType;

        this.form.customerPersonList[0].idCard = res.data.idNo;

        this.form.customerPersonList[0].frontCertificateUrl =
          res.data.frontCertificateUrl;

        this.form.customerPersonList[0].backCertificateUrl =
          res.data.backCertificateUrl;

        this.cardList[0].prevIdCard = [
          { url: res.data.frontCertificateUrl, isImage: true },
        ];

        this.cardList[0].backIdCard = [
          { url: res.data.backCertificateUrl, isImage: true },
        ];
      });
    },

    //房源详情

    getHouseDetail(id) {
      requestHouseDetailId(id)
        .then((res) => {
          console.log(res.data);
          this.form.type = "1"; //1：新签，2：续签，3：换房，4：转租

          this.form.houseId = res.data.id;

          this.houseNow = res.data;

          this.ownerType = res.data.ownerType;
          this.disable.house = true;

          requestHouseType(this.houseNow.id, 2).then((resData) => {
            this.rentTypeList = resData.data;

            this.rentTypeNow = this.$route.query.roomNo;

            let rentTypeNow = resData.data.find((d) => {
              return d.roomNo == this.$route.query.roomNo;
            });

            this.form.roomId = rentTypeNow.roomId;

            this.form.rentType = this.rentTypeNow === null ? "2" : "1";

            this.getPropertyFee();
          });
        })

        .catch((err) => {
          console.log(err);
        });
    },

    //房间详情

    getRoomDetail(id) {
      requestRoomDetailID(id).then((res) => {});
    },

    //预定

    getDestineContractDetail(id) {
      requestDestineContractDetail(id).then((res) => {
        this.disable.house = true;

        this.disable.room = true;

        this.disable.customer = true;

        this.form.type = "1"; //1：新签，2：续签，3：换房，4：转租

        this.form.destineId = res.data.id;

        this.form.houseId = res.data.houseId;

        this.form.roomId = res.data.roomId;

        this.form.communityId = res.data.communityId;

        this.form.customerId = res.data.customerId;

        this.form.rentType = res.data.type;

        this.form.transferId = res.data.transferId;

        this.form.customerPhone = res.data.phone;

        this.form.customerName = res.data.name;

        this.form.customerType = res.data.customerType || 1;

        this.form.orgName = res.data.orgName;

        this.form.orgNo = res.data.orgNo;

        this.form.idType = res.data.idType;

        this.form.idNo = res.data.idNo;

        this.form.email = res.data.email;

        this.form.company = res.data.company;

        this.form.position = res.data.position;

        this.form.contactName = res.data.contactName;

        this.form.contactRelation = res.data.contactRelation;

        this.form.contactPhone = res.data.contactPhone;

        this.form.persons = res.data.persons ? res.data.persons / 1 : 1;

        this.form.customerPersonList = [];

        this.contractorFront = [
          {
            url: res.data.frontCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`,

            isImage: true,
          },
        ];

        this.form.contractorFront = res.data.frontCertificateUrl;

        this.contractorBack = [
          {
            url: res.data.backCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`,

            isImage: true,
          },
        ];

        this.form.contractorBack = res.data.backCertificateUrl;

        this.cardList = [];

        if (res.data.persons) {
          for (let i = 0; i < res.data.persons; i++) {
            this.form.customerPersonList.push({
              name: "",

              phone: "",
              id: "",
              idType: "",

              idCard: "",

              frontCertificateUrl: "",

              backCertificateUrl: "",
            });

            this.cardList.push({
              prevIdCard: [],

              backIdCard: [],
            });
          }
        } else {
          this.form.customerPersonList.push({
            name: "",

            phone: "",
            id: "",
            idType: "",

            idCard: "",

            frontCertificateUrl: "",

            backCertificateUrl: "",
          });

          this.cardList.push({
            prevIdCard: [],

            backIdCard: [],
          });
        }

        this.form.customerPersonList[0].name = res.data.name;

        this.form.customerPersonList[0].phone = res.data.phone;

        this.form.customerPersonList[0].idType =
          this.form.customerType == 1 ? res.data.idType : "";

        this.form.customerPersonList[0].idCard =
          this.form.customerType == 1 ? res.data.idNo : "";

        this.form.customerPersonList[0].frontCertificateUrl =
          this.form.customerType == 1 ? res.data.frontCertificateUrl : "";

        this.form.customerPersonList[0].backCertificateUrl =
          this.form.customerType == 1 ? res.data.backCertificateUrl : "";

        this.cardList[0].prevIdCard = [
          { url: res.data.frontCertificateUrl  + `${isAddTextMask?imgMaskUrl:''}`, isImage: true },
        ];

        this.cardList[0].backIdCard = [
          { url: res.data.backCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`, isImage: true },
        ];

        this.form.amount = res.data.amount;

        this.houseNow.address = res.data.houseAddress;

        this.rentTypeNow = this.form.rentType == "2" ? null : res.data.roomNo.slice(0,1);
         this.form.autoPowerOff = "";
        requestHouseType(res.data.houseId, 2).then((resData) => {
          this.rentTypeList = resData.data;
           if (this.rentTypeNow || this.rentTypeNow == null) {
          let rentTypeNow = this.rentTypeList.find((d) => {
            return d.roomNo == this.rentTypeNow;
          });

          this.eleWaterMeterShow = rentTypeNow.eleWaterMeterShow;
        }
       
          this.getPropertyFee();
        });

        //时间控制

      
      
                let tomorrow = getNdaysDate(formatDate(new Date()), 1)+
          " 00:00:00"
        if (res.data.emptyDate > res.data.destineCreateDate) {
          //预定时是待保洁

          this.form.startRangeDate = res.data.emptyDate;

          let t7 = getNdaysDate(res.data.emptyDate, 7);

          this.form.endRangeDate = t7 < tomorrow ? t7 : tomorrow;
        } else {
          //预定时是空置

          this.form.startRangeDate = res.data.destineCreateDate;

          this.form.endRangeDate =
            res.data.orderDate < tomorrow ? res.data.orderDate : tomorrow;
        }

        this.form.endRangeDate = tomorrow;
      });
    },

    //第一步

    //搜索房源

    onSearchHouse() {
      if (!this.searchValueHouse) return;

      this.searchLoad = true;

      this.houseList = [];

      requestHouseList({ address: this.searchValueHouse }).then((res) => {
        this.searchLoad = false;

        this.houseList = res.data || [];
      });
    },

    //搜索取消

    onCancel() {
      this.showHouse = false;
      this.showCheckPerson = false;
      this.showCustomer = false;
    },

    //选择房源

    changeHouse(house) {
      requestHouseType(house.id, 2).then((res) => {
        this.houseNow = house;

        this.form.houseId = house.id;

        this.form.address = house.address;
        this.form.communityId = house.communityId;

        this.form.priceSkuId = house.priceSkuId;

        this.form.communityContractId = house.communityContractId;

        this.form.communityType = house.type;
        this.existEle = house.existEle;
        this.existWater = house.existWater;
        this.showHouse = false;

        this.form.rentType = "";
        this.form.ownerType = house.ownerType;
        this.ownerType = house.ownerType;
        this.rentTypeNow = "";

        this.rentTypeList = res.data;

        //水电燃度数

        this.houseDegrees = {
          lastElectricMax: house.lastElectricMax / 1,

          lastElectricMin: house.lastElectricMin / 1,

          lastElectricTotal: house.lastElectricTotal / 1,

          lastGas: house.lastGas / 1,

          lastWater: house.lastWater / 1,
        };
      });
    },

    // 选择房间

    changeRentType(item, disabled) {
      if (disabled) return;

      this.ifChangeHouse = true;

      let rentTypeNow =
        this.rentTypeList.find((d) => {
          return d.roomNo == this.rentTypeNow;
        }) || {};
      this.eleWaterMeterShow = rentTypeNow.eleWaterMeterShow;
      this.form.roomId = rentTypeNow.roomId;

      this.form.rentType = rentTypeNow.rentType;
      this.form.autoPowerOff = "";
      this.form.address = this.houseNow.address + rentTypeNow.roomNo;

      this.activeMax = 0;

      if (!this.$route.query.changeHouseContractId) {
        //清空日期及费用项

      
         let tomorrow = formatDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000* this.startDateAfterDays)) +
          " 00:00:00"
         ;
        this.form.startRangeDate = "";

        this.form.endRangeDate = tomorrow;

        this.form.startDate = ""; //开始日期
 this.form.activityId = ""
        this.form.leaseMonth = ""; //租期月

        this.form.leaseDay = ""; //租期日

        this.form.endDate = ""; //结束日期

        this.form.payMonth = ""; //付几

        this.form.depositMonth = ""; //押几

        this.form.rental = ""; //租金
 this.form.activityRental = "";
        this.form.deposit = ""; //押金

        this.form.propertyContractId = ""; //业主合约id

        this.form.amount = ""; //定金

        this.form.serviceFee = ""; //服务费

        this.form.singleMatterList = []; //一次性费用

        this.form.periodMatterList = []; //周期性费用

        this.form.remark = "";

        this.form.electricTotalUrl = ""; //电总图

        this.form.electricMaxUrl = ""; //电峰图

        this.form.electricMinUrl = ""; //电谷图

        this.form.electricTotal = ""; //电总

        this.form.electricMax = ""; //电峰

        this.form.electricMin = ""; //电谷

        this.form.waterUrl = ""; //水图

        this.form.water = ""; //水

        this.form.gasUrl = ""; //燃气图

        this.form.gas = ""; //燃气

        this.form.otherUrl = ""; //其它图

        this.electricTotalUrl = []; //电总

        this.electricMaxUrl = []; //电峰

        this.electricMinUrl = []; //电谷

        this.waterUrl = []; //水

        this.gasUrl = []; //燃气

        this.otherUrl = []; //其他
      } else {
        this.form.startDate = ""; //开始日期

        this.form.payMonth = ""; //付几

        this.form.depositMonth = ""; //押几
      }

      this.getSaveContractDetail();

      this.getPropertyFee();

      this.form.advanceFee =
        this.form.rentType == 1
          ? this.prepayment.sharingPrice
          : this.prepayment.wholePrice; //水电燃预缴费

      if (this.form.type == 3) this.getSku();
    },

    //搜索客户

    onSearchCustomer() {
      if (!this.searchValueCustomer) return;

      this.searchLoad = true;

      this.customerList = [];

      requestDesCustomerList({
        phone: this.searchValueCustomer,

        origin: "crm",
      }).then((res) => {
        this.searchLoad = false;

        this.customerList = res.data;
      });
    },
    // 搜索入住人
    onSearchCheckPerson() {
      if (!this.searchValueCheckPerson) return;

      this.searchLoad = true;

      this.checkPersonList = [];

      requestCheckPersonList({
        phone: this.searchValueCheckPerson,

        origin: "crm",
      }).then((res) => {
        this.searchLoad = false;

        this.checkPersonList = res.data;
      });
    },
    //选择客户

    changeCustomer(customer) {
      if ((this.form.type == 1 && !this.form.status) || !this.form.type) {
        this.resetValue();
      }

      if (customer.isVerified) {
        this.customerNow = customer;

        this.form.customerId = customer.id;

        this.form.customerPhone = customer.phone;

        this.form.customerName = customer.name;

        this.form.customerType = 1;
        // this.form.autoPowerOff = this.eleWaterMeterShow?(this.form.customerType == 1? 1:0):0
        this.form.orgNo = customer.orgNo;

        this.form.orgName = customer.orgName;

        this.form.idType = customer.idType;

        this.form.idNo = customer.idNo;

        this.form.email = customer.email;

        this.form.company = customer.company;

        this.form.position = customer.position;

        this.form.contactName = customer.contactName;

        this.form.contactRelation = customer.contactRelation;

        this.form.contactPhone = customer.contactPhone;

        this.form.persons = customer.persons || 1;

        this.form.customerPersonList = [];

        this.contractorFront = [
          {
            url: customer.frontCertificateUrl  + `${isAddTextMask?imgMaskUrl:''}`,

            isImage: true,
          },
        ];
        
        this.form.contractorFront = customer.frontCertificateUrl;

        this.contractorBack = [
          {
            url: customer.backCertificateUrl  + `${isAddTextMask?imgMaskUrl:''}`,

            isImage: true,
          },
        ];

        this.form.contractorBack = customer.backCertificateUrl;

        this.cardList = [];

        for (let i = 0; i < (customer.persons || 1); i++) {
          this.form.customerPersonList.push({
            name: "",

            phone: "",
            id: "",
            idType: "",

            idCard: "",

            frontCertificateUrl: "",

            backCertificateUrl: "",
          });

          this.cardList.push({
            prevIdCard: [],

            backIdCard: [],
          });
        }

        this.form.customerPersonList[0].name = customer.name;

        this.form.customerPersonList[0].phone = customer.phone;

        this.form.customerPersonList[0].idType = customer.idType;

        this.form.customerPersonList[0].idCard = customer.idNo;

        this.form.customerPersonList[0].frontCertificateUrl =
          customer.frontCertificateUrl;

        this.form.customerPersonList[0].backCertificateUrl =
          customer.backCertificateUrl;

        this.cardList[0].prevIdCard = [
          { url: customer.frontCertificateUrl  + `${isAddTextMask?imgMaskUrl:''}`, isImage: true },
        ];

        this.cardList[0].backIdCard = [
          { url: customer.backCertificateUrl  + `${isAddTextMask?imgMaskUrl:''}`, isImage: true },
        ];

        this.showCustomer = false;

        if (this.rentTypeNow || this.rentTypeNow == null) {
          this.getSaveContractDetail();
        }
      } else {
        //未实名认证

        this.$toast.fail("该客户未实名认证,暂不可签约");

        return;
      }
    },
    changeCheckPerson(item) {
      console.log(item);

      this.form.customerPersonList[this.checkPersonIndex].backCertificateUrl =
        item.backCertificateUrl;
      this.form.customerPersonList[this.checkPersonIndex].frontCertificateUrl =
        item.frontCertificateUrl;
      //   this.form.customerPersonList[this.personIndex].frontCertificateUrl =
      //   this.form.customerType == 1 ? res.data.frontCertificateUrl : "";

      // this.form.customerPersonList[0].backCertificateUrl =
      //   this.form.customerType == 1 ? res.data.backCertificateUrl : "";

      this.cardList[this.checkPersonIndex].prevIdCard = [
        { url: item.frontCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`, isImage: true },
      ];

      this.cardList[this.checkPersonIndex].backIdCard = [
        { url: item.backCertificateUrl + `${isAddTextMask?imgMaskUrl:''}`, isImage: true },
      ];
      this.form.customerPersonList[this.checkPersonIndex].id = item.id;
      this.form.customerPersonList[this.checkPersonIndex].idCard = item.idCard;
      this.form.customerPersonList[this.checkPersonIndex].idType = item.idType;
      this.form.customerPersonList[this.checkPersonIndex].name = item.name;
      this.form.customerPersonList[this.checkPersonIndex].phone = item.phone;
      this.checkPersonList = []
      this.showCheckPerson = false;
    },
    //切换客户类型

    changeCustomerType(item) {
      if (this.$route.query.changeHouseContractId) {
        return;
      }

      if (item == 1) {
        this.form.orgName = "";

        this.form.orgNo = "";
      }
      this.form.persons = 1;
      this.form.customerPersonList = [
        {
          name: "",

          phone: "",
          id: "",
          idType: "",

          idCard: "",

          frontCertificateUrl: "",

          backCertificateUrl: "",
        },
      ];

      this.cardList = [
        {
          prevIdCard: [],

          backIdCard: [],
        },
      ];
      //  this.form.autoPowerOff = this.eleWaterMeterShow?(this.form.customerType == 1? 1:0):0
    },

    //计算物业费

    getPropertyFee() {
      requestPropertyFee({
        houseId: this.form.houseId,

        rentType: this.form.rentType,
      }).then((res) => {
        this.form.condoFee = res.data;
      });
    },
    //获取预缴费规则
    getParmeterRules() {
      requestParameterRules()
        .then((res) => {
          // console.log('预缴费',res)
          this.prepayment = res.data.prepayment;
          // console.log(this.prepayment)
        })
        .catch((err) => {
          console.log(err);
        });
    },
     //获取合约开始时间延后天数
      getStartDays() {
      requestParameterRules()
        .then((res) => {
          this.startDateAfterDays = res.data&&res.data.prepayment.startDateAfterDays?res.data.prepayment.startDateAfterDays : 1;
          console.log(this.startDateAfterDays)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDepositRules() {
      requestDepositRules()
        .then((res) => {
           this.serviceFeeRate =
              res.data.servicePenalFee &&
              res.data.servicePenalFee.serviceFeeRate
                ? res.data.servicePenalFee.serviceFeeRate
                : 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPropertyFeeAwait(houseId, rentType) {
      return new Promise((resolve, reject) => {
        requestPropertyFee({
          houseId: houseId,

          rentType: rentType,
        })
          .then((res) => {
            resolve(res.data);
          })

          .catch((err) => {
            reject(err);
          });
      });
    },
    // 签约人证件照
    contractFrontSuccess(item){
      this.contractorFront = [
        {
            url: this.upload_qiniu_addr + item.file.key + `${isAddTextMask?imgMaskUrl:''}`,
             isImage: true,
        }
      ]
      this.$refs.form1.resetValidation('contractorFront')
        for(let k = 0 ; k < this.form.customerPersonList.length; k++){
        console.log(this.form.customerPhone,this.form.customerPersonList[k].phone)
        if(this.form.customerPhone == this.form.customerPersonList[k].phone){

            this.form.customerPersonList[k].frontCertificateUrl = this.upload_qiniu_addr + item.file.key
            this.cardList[k].prevIdCard =  [
                      {
                        url: this.upload_qiniu_addr + item.file.key + `${isAddTextMask?imgMaskUrl:''}`,

                        isImage: true,
                      },
                    ];
        }
      }
  
    },
     contractBackSuccess(item){
      this.contractorBack = [
        {
            url: this.upload_qiniu_addr + item.file.key + `${isAddTextMask?imgMaskUrl:''}`,
             isImage: true,
        }
      ]
      this.$refs.form1.resetValidation('contractorBack')
        for(let k = 0 ; k < this.form.customerPersonList.length; k++){
      
        if(this.form.customerPhone == this.form.customerPersonList[k].phone){
            this.form.customerPersonList[k].backCertificateUrl = this.upload_qiniu_addr + item.file.key
            this.cardList[k].backIdCard =  [
                      {
                        url: this.upload_qiniu_addr + item.file.key + `${isAddTextMask?imgMaskUrl:''}`,

                        isImage: true,
                      },
                    ];
        }
      }
  
    },
    // 证件号修改
    idNoChange(){
          for(let k = 0 ; k < this.form.customerPersonList.length; k++){
       
        if(this.form.customerPhone == this.form.customerPersonList[k].phone){

            this.form.customerPersonList[k].idCard= this.form.idNo
        }
      }
    },
    //入住人证件类型change

    changePersonType(item, index) {
      console.log(item);
      if (this.form.customerPersonList[this.personIndex].idType != index + 1) {
        this.form.customerPersonList[this.personIndex].idCard = "";

        this.form.customerPersonList[this.personIndex].frontCertificateUrl = "";

        this.form.customerPersonList[this.personIndex].backCertificateUrl = "";

        this.cardList[this.personIndex].prevIdCard = [];

        this.cardList[this.personIndex].backIdCard = [];
      }

      this.form.customerPersonList[this.personIndex].idType = item.value;

      this.showIdType1 = false;

      this.$refs.form1.resetValidation("personidType" + this.personIndex);

      this.$refs.form1.resetValidation("personidCard" + this.personIndex);
    },

    next1() {
      console.log(this.form.customerPersonList);
      if (
        this.form.customerPersonList &&
        this.form.customerPersonList.length < 1
      ) {
        this.$toast.fail({
          message: "入住人不能为空",
        });
        return false;
      }
      for (let i = 0; i < this.form.customerPersonList.length; i++) {
        let d = this.form.customerPersonList[i];

        for (let j = i + 1; j < this.form.customerPersonList.length; j++) {
          const e = this.form.customerPersonList[j];

          if (d.idType == e.idType && d.idCard == e.idCard) {
            this.$toast.fail({
              message:
                "租客" + (i + 1) + "的证件号和租客" + (j + 1) + "的证件号相同",
            });

            return;
          }

          if (d.phone == e.phone) {
            this.$toast.fail({
              message:
                "租客" + (i + 1) + "的电话和租客" + (j + 1) + "的电话相同",
            });

            return;
          }
        }
      }
      this.$refs.form1.validate().then((valid) => {
        this.form.operationNo = this.active / 1 + 1;

        this.form.type = this.form.type ? this.form.type : "1"; //1：新签，2：续签，3：换房，4：转租

        //图片处理
      
        this.form.contractorFront = this.contractorFront.length
          ? isAddTextMask?this.contractorFront[0].url.replace(imgMaskUrl, ""):this.contractorFront[0].url
          : ""; //签约人身份证正面

        this.form.contractorBack = this.contractorBack.length
          ?  isAddTextMask?this.contractorBack[0].url.replace(imgMaskUrl, ""):this.contractorBack[0].url
          : ""; //签约人身份证反面

        this.form.businessLicense = this.businessLicense.length
          ? this.businessLicense[0].url
          : ""; //签约人营业执照

        this.form.source = "2";

        if (this.form.startDate) {
          //租期天数不可大于当月最大天数

          let endDate = getEndDate(this.form.startDate.slice(0, 10), 0, 1, 0);

          this.leaseDayValid = parseInt(
            (new Date((endDate + " 00:00:00").replace(/-/g, "/")).getTime() -
              new Date(this.form.startDate.replace(/-/g, "/")).getTime()) /
              1000 /
              60 /
              60 /
              24 +
              1
          );
        }

        //新签暂存状态合约重新确定开始日期范围

        if (
          !this.form.destineId &&
          this.form.type == 1 &&
          (!this.form.status || this.form.status == 1) &&
          this.form.isResign != 1
        ) {
           
   
             this.currentDate =new Date(this.form.startDate?this.form.startDate:new Date())

              let tomorrow = formatDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000* this.startDateAfterDays)) +
          " 00:00:00"
         ;

          this.form.endRangeDate = tomorrow;
        }

        if (
          (this.form.advanceFee !== null || this.form.advanceFee !== "") &&
          this.ifChangeHouse
        ) {
          console.log("获取最新");
          this.form.advanceFee =
            this.form.rentType == 1
              ? this.prepayment.sharingPrice
              : this.prepayment.wholePrice; //水电燃预缴费
          this.ifChangeHouse = false;
        }

        if (!this.isZancun) {
          this.active = 1;

          //获取业主合约详情

          this.getProperty();
    

          return;
        }
          if (
            (this.form.type == 1 && !this.form.status) ||
            this.form.type == 2 ||
            this.form.type == 3
          ){
               requestPropertyFee({
              houseId: this.form.houseId,

              rentType: this.form.rentType,
            }).then(res=>{
               this.form.condoFee = res.data;
               requestContractCreate(this.form).then((res) => {
          requestContractDetail(res.data).then((resData) => {
            this.toValue(resData, {});
  
            this.getProperty();
          
          });
          
          this.active = 1;
        });
            }) .catch((err) => {
                this.saveLoad = false;
              });
          }  else{
             requestContractCreate(this.form).then((res) => {
          requestContractDetail(res.data).then((resData) => {
            this.toValue(resData, {});
  
            this.getProperty();
          
          });
          
          this.active = 1;
        });
          }
       
      });
    },

    //第二步

    //日期确定

    startDateConfirm(val) {
      this.form.startDate = formatDate(val) + " 00:00:00";

      this.showStartDate = false;

      //租期天数不可大于当月最大天数
    console.log("fuff")
      let endDate = getEndDate(this.form.startDate.slice(0, 10), 0, 1, 0);

      this.leaseDayValid = parseInt(
        (new Date((endDate + " 00:00:00").replace(/-/g, "/")).getTime() -
          new Date(this.form.startDate.replace(/-/g, "/")).getTime()) /
          1000 /
          60 /
          60 /
          24 +
          1
      );

      if (this.form.type == 3 || this.form.type == 4) {
        if (this.form.startDate && this.form.endDate) {
          //转租换房算租期

          let param = {
            startDate: this.form.startDate.slice(0, 10),

            endDate: this.form.endDate.slice(0, 10),
          };

          requestLease(param).then((resData) => {
            // debugger;

            this.form.leaseMonth = resData.data.months;

            this.form.leaseDay = resData.data.days;
          });
        }
      } else {
        //非转租换房计算结束日期

        this.getEndDate();
      }

      //获取业主合约详情

      this.getProperty();
    },
    changeMonth(value) {
  
      if (
        (!this.form.leaseMonth || this.form.leaseMonth == "0") &&
        (!this.form.leaseDay || this.form.leaseDay == "0")
      ) {
        return;
      }
      console.log("changeMonth",this.form.leaseMonth,this.form.leaseDay)
      this.payDeposit = "";

      this.form.payMonth = "";

      this.form.depositMonth = "";

      this.form.rental = "";

      this.form.deposit = "";
       this.form.activityRental = ""
      // this.form.serviceFee = "";
      // this.form.leaseMonth = this.form.leaseMonth.replace(/[^\d]/g, "") / 1;

      this.skuPriceList = [];

      this.getSku();
    },
    //获取支付下拉

    getSku(d) {
          console.log("wt");
      let param = d || {
        priceSkuId: this.form.priceSkuId,

        lease: this.form.leaseMonth / 1 || 1,

        houseId: this.form.houseId,

        roomId: this.form.roomId,

        rentType: this.form.rentType,
          activityId: this.form.activityId
      };
      
      requestSkuPrice(param).then((res) => {
         this.skuPriceList = res.data;
        let payTypeList = [];

        res.data.forEach((d) => {
          payTypeList.push({
            label:
              d.payMonth == 999
                ? "全额付"
                : "付" + d.payMonth + "押" + d.depositMonth,

            payMonth: d.payMonth,

            depositMonth: d.depositMonth,
            activityPrice:d.activityPrice,
            price: d.price,
            depositPrice:d.depositPrice,
            depositInputEnabled:d.depositInputEnabled

          });
        });

        this.payTypeList = payTypeList;
        console.log("payTypeList",payTypeList)
        let minObj = this.skuPriceList.find((d) => {
            return (
              d.payDepositType ==
              this.form.payMonth + "-" + this.form.depositMonth
            );
          });
           console.log(minObj);
          if (!minObj) {
            console.log("!minobh")
             if (this.form.status == 3) {
              this.payDeposit = {
              payDepositType: this.form.payMonth + "-" + this.form.depositMonth,

              payMonth: this.form.payMonth,

              depositMonth: this.form.depositMonth,
            };
                this.skuPriceList = [this.payDeposit];
              }else{
                  this.form.payMonth = "";
            this.form.depositMonth = "";
               

              }
          }else{
             this.depositInputEnabled = minObj.depositInputEnabled;
            this.depositPrice = minObj.depositPrice;
          }
        console.log(this.payTypeList);
      }).catch(err=>{
        console.log(err)
         if (this.form.status == 3) {
              this.payDeposit = {
              payDepositType: this.form.payMonth + "-" + this.form.depositMonth,

              payMonth: this.form.payMonth,

              depositMonth: this.form.depositMonth,
            };
                this.skuPriceList = [this.payDeposit];
              }else{
                  this.form.payMonth = "";
            this.form.depositMonth = "";
              }
      });
    },

    //获取业主合约详情

    getProperty() {
      if (!this.form.startDate) {
        return;
      }

      //获取业主合约详情

      if (this.form.communityType == 1) {
        //分散式
        console.log("this.form",this.form)
        requestFContractDetail(this.form.houseId, {
          startDate: this.form.startDate,
        }).then((res) => {
          if (res.data) {
            this.propertyContract.quitDate = res.data.endDate;

            this.propertyContract.number = res.data.number;

            this.form.propertyContractId = res.data.id;

            this.validStartDate = true;
          } else {
            this.validStartDate = false;

            this.$toast.fail("当前日期暂无业主合约");
          }
          // console.log(this.form.contract.status)

          if (
            this.$route.query.transferContractId ||
            this.$route.query.changeHouseContractId ||
            this.$route.query.oldContractId ||
            this.form.type == 3 ||
            this.form.type == 4
          ) {
             console.log("???");
            if (this.form.type != 4 && this.form.status != 3) {
              console.log("???");
              //转租不走sku
              let param = {
                priceSkuId: this.form.priceSkuId,

                lease: this.form.leaseMonth / 1 || 1,

                houseId: this.form.houseId,

                roomId: this.form.roomId,

                rentType: this.form.rentType,
                 activityId: this.form.activityId
              };

              requestSkuPrice(param).then((res) => {
                this.skuPriceList = res.data;
                let payTypeList = [];

                res.data.forEach((d) => {
                  payTypeList.push({
                    label:
                      d.payMonth == 999
                        ? "全额付"
                        : "付" + d.payMonth + "押" + d.depositMonth,

                    payMonth: d.payMonth,

                    depositMonth: d.depositMonth,

                    price: d.price,
                     depositPrice:d.depositPrice,
                    depositInputEnabled:d.depositInputEnabled
                  });
                });

                this.payTypeList = payTypeList;
                let minObj = this.skuPriceList.find((d) => {
                  return (
                    d.payDepositType ==
                    this.form.payMonth + "-" + this.form.depositMonth
                  );
                });
                 if (!minObj) {
                      this.form.payMonth = "";
                      this.form.depositMonth = "";
                      return false;
                    }
                this.rentalMin = minObj ? minObj.price : 0;

                this.form.rental = this.rentalMin;

                // this.form.deposit = this.rentalMin;
                    this.depositInputEnabled = minObj.depositInputEnabled;
            this.depositPrice = minObj.depositPrice;
            this.form.deposit = minObj.depositPrice
              }).catch(err=>{
                this.form.payMonth = "";
                   this.form.depositMonth = "";
              });
            } else {
              this.skuPriceList = [this.payDeposit];
            }
          } else {
            console.log("fuck",this.form)
            this.getEndDate();
             this.payDeposit = {
              payDepositType: this.form.payMonth + "-" + this.form.depositMonth,

              payMonth: this.form.payMonth,

              depositMonth: this.form.depositMonth,
            };
             if (this.form.status == 3) {
                this.skuPriceList = [this.payDeposit];
              } else {
                this.getSku();
              }
           
           
          }
        });
      } else {
        //集中式

        requestJContractDetail(this.form.communityContractId).then((res) => {
          if (res.data) {
            this.propertyContract.quitDate = res.data.contract.endDate;

            this.propertyContract.number = res.data.contract.number;

            this.form.propertyContractId = res.data.contract.id;

            this.validStartDate = true;

            if (
              //更新费用项  除了转租和打回修改 换续重签新签都拉取最新费用项
              (!(this.form.rental / 1) &&
                !this.$route.query.transferContractId) ||
              this.$route.query.oldContractId ||
              (this.$route.query.contractId && this.form.status != 3)
            ) {
              let periodMatterList = [];

              (res.data.periodMatterList || []).forEach((d) => {
                if (d.matterNumber == "FWF") {
                  this.form.serviceFee = d.amount;
                } else {
                  periodMatterList.push(d);
                }
              });

              this.form.periodMatterList = periodMatterList;

              this.form.singleMatterList = res.data.singleMatterList;
            }
          }
          if (
            this.form.startDate > res.data.contract.endDate ||
            this.form.startDate < res.data.contract.activeDate
          ) {
            this.validStartDate = false;

            this.$toast.fail("当前日期暂无业主合约");
          }
          if (
            this.$route.query.transferContractId ||
            this.$route.query.changeHouseContractId ||
            this.$route.query.oldContractId ||
            this.form.type == 3 ||
            this.form.type == 4
          ) {
            if (this.form.type != 4 && this.form.status != 3) {
              //转租不走sku
              let param = {
                priceSkuId: this.form.priceSkuId,

                lease: this.form.leaseMonth / 1 || 1,

                houseId: this.form.houseId,

                roomId: this.form.roomId,

                rentType: this.form.rentType,
                 activityId: this.form.activityId
              };
              requestSkuPrice(param).then((res) => {
                this.skuPriceList = res.data;
                let payTypeList = [];

                res.data.forEach((d) => {
                  payTypeList.push({
                    label:
                      d.payMonth == 999
                        ? "全额付"
                        : "付" + d.payMonth + "押" + d.depositMonth,

                    payMonth: d.payMonth,

                    depositMonth: d.depositMonth,

                    price: d.price,
                    depositPrice:d.depositPrice,
                    depositInputEnabled:d.depositInputEnabled
                  });
                });

                this.payTypeList = payTypeList;
                let minObj = this.skuPriceList.find((d) => {
                  return (
                    d.payDepositType ==
                    this.form.payMonth + "-" + this.form.depositMonth
                  );
                });
                  if (!minObj) {
                        this.form.payMonth = "";
                        this.form.depositMonth = "";
                        return false;
                      }
                this.rentalMin = minObj ? minObj.price : 0;

                this.form.rental = this.rentalMin;

                // this.form.deposit = this.rentalMin;
                    this.depositInputEnabled = minObj.depositInputEnabled;
            this.depositPrice = minObj.depositPrice;
            this.form.deposit = minObj.depositPrice
              }).catch(err=>{
                      this.form.payMonth = "";
                         this.form.depositMonth = "";
                  });
            } else {
              this.skuPriceList = [this.payDeposit];
            }
          } else {
            this.getEndDate();
            
            this.payDeposit = {
              payDepositType: this.form.payMonth + "-" + this.form.depositMonth,

              payMonth: this.form.payMonth,

              depositMonth: this.form.depositMonth,
            };
              if (this.form.status == 3) {
                this.skuPriceList = [this.payDeposit];
              } else {
                this.getSku();
              }
          }
        });
      }
    },

    // 计算结束日期

    getEndDate() {
    
      
      if (
        this.form.startDate &&
        (this.form.leaseMonth / 1 || this.form.leaseDay / 1)
      ) {
        let endDate = getEndDate(
          this.form.startDate.slice(0, 10),

          0,

          this.form.leaseMonth,

          this.form.leaseDay
        );

        this.form.endDate = endDate + " 00:00:00";

        this.$refs.form2.validate("endDate");
      }
    },
    getActivityList() {
      console.log("getActivityList");
      let param = {
        houseId: this.form.houseId,

        roomId: this.form.roomId,

        rentType: this.form.rentType,
      };
     requestContractActivityList(param)
        .then((res) => {
          console.log(res);
             res.data = res.data&&res.data.length ? res.data : [];
         res.data.unshift({
              name: "不参加",
              id: "",
              type: "",
              ftype: "",
            });
           
          if(this.form.status == 3){
            console.log(this.form.activity )
            this.activity = this.form.activity 
            || {
              name: "不参加",
              id: "",
              type: "",
              ftype: "",
            }
            this.activityList = []
            this.activityList.push(this.form.activity||{
              name: "不参加",
              id: "",
              type: "",
              ftype: "",
            })
          }else{
             let arr = res.data.find((d) => {
              return d.id == this.form.activityId || "";
            })
            console.log(arr)
            if(arr&&arr.id){
              this.activity = arr
              this.form.activityId = arr.id
              this.activityList = res.data
            }else{
              this.form.activityId = ""
              this.activity = {
                name: "不参加",
                id: "",
                type: "",
                ftype: "",
              }
              this.activityList = res.data
            }
          }
        })
        .catch((err) => console.log(err));
    },
    changeActivity(item){
       this.form.leaseMonth = "";
      this.form.leaseDay = ""
      this.form.activityRental = ""
        this.activity = item;
        this.form.activityId = item.id;
        console.log(this.form.activityId)
        if(item.type == 3){
          this.form.leaseMonth = item.giveDays>0? item.live/1: (item.live + item.give) / 1;
           this.form.leaseDay = item.giveDays? item.giveDays:0;
          this.getEndDate();
        }
         this.changeMonth();
        this.showActivity = false
       
    },
  //   changepayTypeList(item){
  //     console.log(item)
  //      this.form.payMonth = item.payMonth;

  //           this.form.depositMonth = item.depositMonth;
  // this.depositInputEnabled = item.depositInputEnabled;
  //      this.form.deposit= item.depositPrice;
  //      this.depositPrice = item.depositPrice;
  //           this.form.rental = item.price;
  //           this.form.activityRental = item.activityPrice;
  //           this.form.deposit = this.accMul(item.price, item.depositMonth);
  //           changeServiceFee();
  //           showPayType = false
  //   },
    //获取事项下拉

    getMatter() {
      requestExpensesContractS().then((res) => {
        res.data.forEach((d) => {
          d.disabled = false;

          this.form.singleMatterList.forEach((e) => {
            if (d.name == e.matterName) {
              d.disabled = true;
            }
          });
        });

        this.matterListS = res.data;
      });

      requestExpensesContractP().then((res) => {
        res.data.forEach((d) => {
          d.disabled = false;

          this.form.periodMatterList.forEach((e) => {
            if (d.name == e.matterName) {
              d.disabled = true;
            }
          });
        });

        this.matterListP = res.data;
      });
    },

    //添加费用

    addAmountS(item, index) {
      if (item.disabled) return;

      this.showFeeS = false;

      //一次性

      this.form.singleMatterList.push({
        matterId: item.id,

        matterName: item.name,

        amount: "",
      });

      this.matterListS[index].disabled = true;

      this.matterListS = this.matterListS.slice(0);
    },

    addAmountP(item, index) {
      if (item.disabled) return;

      this.showFeeP = false;

      //周期性

      this.form.periodMatterList.push({
        matterId: item.id,

        matterName: item.name,

        amount: "",
      });

      this.matterListP[index].disabled = true;

      this.matterListP = this.matterListP.slice(0);
    },

    //删除费用

    subAmountS(index) {
      this.form.singleMatterList.splice(index, 1);

      this.matterListS.forEach((d) => {
        d.matterId == this.form.singleMatterList[index.id]
          ? (d.disabled = false)
          : "";
      });

      this.matterListS = this.matterListS.slice(0);
    },

    subAmountP(index) {
      this.form.periodMatterList.splice(index, 1);

      this.matterListP.forEach((d) => {
        d.matterId == this.form.periodMatterList[index.id]
          ? (d.disabled = false)
          : "";
      });

      this.matterListP = this.matterListP.slice(0);
    },
    changeServiceFee() {
      console.log(this.ownerType == 2, this.$route.query.ownerType == 2);
      if (this.ownerType == 2 || this.$route.query.ownerType == 2) {
        console.log(accMul(this.form.rental, this.serviceFeeRate / 100));
        this.form.serviceFee = Math.floor(
          accMul(this.form.rental, this.serviceFeeRate / 100)
        );
      }
    },
    onConfirm(item,index){
      console.log(item)
         this.form.payMonth = item.payMonth;
             this.form.depositMonth = item.depositMonth;
             this.form.rental = item.price;
             this.form.activityRental = item.activityPrice;
              this.depositInputEnabled = item.depositInputEnabled;
               if(!this.depositInputEnabled &&  this.$route.query.prevContractId){
                 this.form.deposit= this.prevContractData.contract.deposit;
               this.depositPrice =  this.prevContractData.contract.deposit
              }else{
                 this.form.deposit= item.depositPrice;
               this.depositPrice = item.depositPrice;
              }
            this.changeServiceFee();
           this.showPayType = false;
    },
    next2() {
      if (!this.validStartDate) {
        this.$toast.fail("当前日期暂无业主合约");
        return;
      }
      this.$refs.form2.validate().then((valid) => {
        if (
          this.form.advanceFee == 0 &&
          !this.form.autoPowerOff &&
          this.eleWaterMeterShow
        ) {
          this.$dialog.confirm({
            title: "提示",
            message: "请确认该合约未收取预缴费且智能水电余额低于0元时不断电?",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            beforeClose: (action, done) => {
              if (action === "confirm") {
                this.form.operationNo = this.active / 1 + 1; //第几步

                if (!this.isZancun) {
                  this.active = 2;
                  done();
                  return;
                }

                requestContractCreate(this.form).then((res) => {
                  requestContractDetail(res.data).then((resData) => {
                    this.toValue(resData, {});
                    done();
                  });

                  this.active = 2;
                });
              } else {
                done();
              }
            },
          });

          return false;
        }
        this.form.operationNo = this.active / 1 + 1; //第几步

        if (!this.isZancun) {
          this.active = 2;

          return;
        }

        requestContractCreate(this.form).then((res) => {
          requestContractDetail(res.data).then((resData) => {
            this.toValue(resData, {});
          });

          this.active = 2;
        });
      });
    },

    //第三步

    //资产详情

    lookAssets(assets) {
      // requestAssetsDetail(id).then(res => {

      //   })

      this.asstesDetail = assets;

      this.showAssets = true;
    },

    next3() {
      this.active = 3;
    },

    //第四步

    //获取七牛token

    getQiniuToken() {
      requestQiniuToken()
        .then((res) => {
          this.qiniuData.token = res.data;
        })

        .catch((err) => {
          console.log(err);
        });
    },

    //图片上传前校验，压缩

    beforeRead(file) {
      const isJPG = file.type === "image/jpeg";

      const isPNG = file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 < 2;

      const isLt8M = file.size / 1024 / 1024 < 8;

      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isJPG && !isPNG) {
        this.$toast.fail("图片只能是 JPG/PNG 格式！");

        return false;
      }

      if (!isLt10M) {
        this.$toast.fail("图片大小不能超过 10MB!");

        return false;
      }

      this.qiniuData.key = Date.now() + file.name;

      return new Promise((resolve, reject) => {
        compressAccurately(file, 400).then((fileMin) => {
          let data = new FormData();

          data.append("token", this.qiniuData.token);

          data.append("key", this.qiniuData.key);

          data.append("file", fileMin);

          request({
            url: this.$store.state.qiniuUpload,

            method: "post",

            processData: false,

            headers: {
              "Content-Type": "multipart/form-data",
            },

            data: data,
          })
            .then((res) => {
              let newFile = fileMin;

              newFile.key = res.key;

              resolve(newFile);
            })

            .catch((err) => {
              console.log(err);

              reject(err);
            });
        });
      });
    },
    // 根据房源判断绑定关系是否存在 水表
    async getHouseWaterExist() {
      let checkRoom = this.form.rentType - 1;
      return requestHouseWaterExist(this.form.houseId, checkRoom)
        .then((res) => {
          this.showWaterModel = !res.data;
          return res;
        })
        .catch((err) => {});
    },
    // 根据房源判断绑定关系是否存在 电表
    async getHouseElectronicExist() {
      let checkRoom = this.form.rentType - 1;
      return requestHouseElectronicExist(this.form.houseId, checkRoom)
        .then((res) => {
          this.showElectronicModel = !res.data;
          return res;
        })
        .catch((err) => {});
    },

    // 根据房源判断绑定关系是否正确 水表
    getHouseWaterExistIsRight() {
      let checkRoom = this.form.rentType - 1;
      return requestHouseWaterIsRight(this.form.houseId, checkRoom)
        .then((res) => {
          this.waterSubmit = res.data;
          return res;
        })
        .catch((err) => {});
    },

    // 根据房源判断绑定关系是否存在 电表
    getHouseElectronicExistIsRight() {
      let checkRoom = this.form.rentType - 1;
      return requestHouseElectronicIsRight(this.form.houseId, checkRoom)
        .then((res) => {
          this.ElectronicSubmit = res.data;
          return res;
        })
        .catch((err) => {});
    },
    getHouseSettlement() {
      return new Promise((resolve, reject) => {
        requestHouseSettlement(this.form.houseId).then((res) => {
          if (res) {
            this.goSettlement = res.data;
            resolve(res);
          }
        });
      });
    },
    getHouseIsOnOff() {
      let checkRoom = this.form.rentType - 1;
      return requestHouseDeviceIsOnOff(this.form.houseId, checkRoom).then(
        (res) => {
          if (res) {
            return res;
          }
        }
      );
    },
    async next4() {
      if (this.saveLoad) return;

      this.$refs.form4.validate().then(async (valid) => {
        this.form.operationNo = this.active / 1 + 1; //第几步

        //图片参数格式

        if (this.imgUp) {
          if (!this.existEle) {
            this.form.electricTotalUrl = this.electricTotalUrl[0].url; //电总

            this.form.electricMaxUrl = this.electricMaxUrl[0].url; //电峰

            this.form.electricMinUrl = this.electricMinUrl[0].url; //电谷
          }
          if (!this.existWater) {
            this.form.waterUrl = this.waterUrl[0].url; //水
          }
          console.log(this.form.waterUrl);
          this.form.gasUrl = this.gasUrl[0].url; //燃气

          let otherUrl = []; //其他

          if (this.otherUrl) {
            this.otherUrl.forEach((d) => {
              otherUrl.push(d.url);
            });
          }

          this.form.otherUrl = otherUrl.join(";");
        }
        this.saveLoad = true;
        // if (!this.showWaterModel || !this.showElectronicModel) {
        //   let wData = await this.getHouseWaterExistIsRight();
        //   let eData = await this.getHouseElectronicExistIsRight();

        //   if (this.waterSubmit != 0) {
        //     this.$toast.fail(
        //       `当前合同所关联的${
        //         this.form.rentType > 1 ? "房源" : "房间"
        //       }【智能水表】设备绑定关系不正确，无法提交，联系运营部负责人，在该房源上重新操作设备绑定后再提交`
        //     );
        //       this.saveLoad = false
        //     return false;
        //   }
        //   if (this.ElectronicSubmit != 0) {
        //     this.$toast.fail(
        //       `当前合同所关联的${
        //         this.form.rentType > 1 ? "房源" : "房间"
        //       }【智能电表】设备绑定关系不正确，无法提交，联系运营部负责人，在该房源上重新操作设备绑定后再提交`
        //     );
        //        this.saveLoad = false
        //     return false;
        //   }
        // }
        // if (
        //   (!this.showWaterModel || !this.showElectronicModel) &&
        //   !this.waterSubmit &&
        //   !this.ElectronicSubmit
        // ) {
        //   let s = await this.getHouseSettlement();

        //   if (this.goSettlement == 0) {
        //     this.$dialog.confirm({
        //       title: "提示",
        //       message: `该${
        //         this.form.rentType > 1 ? "房源" : "房间"
        //       }当天没有结算水电费，请点击下方手动结算按钮待结算成功之后再提交`,
        //       confirmButtonText: "去抄表",
        //       cancelButtonText: "取消",
        //       beforeClose: async (action, done) => {
        //         if (action === "confirm") {
        //           this.saveLoad = true;
        //           let isOnOff = await this.getHouseIsOnOff();
        //           console.log(isOnOff);
        //           if (isOnOff) {
        //             requestGoSettlement(this.form.houseId)
        //               .then((res) => {
        //                 this.$toast.success("手动结算成功!");

        //                 this.saveLoad = false;
        //                 this.type;
        //                 done();
        //               })
        //               .catch((err) => {
        //                 this.saveLoad = false;
        //                 done(false);
        //               });
        //           } else {
        //             this.$toast.fail(
        //               "设备不在线，无法提交，联系运营部负责人，在该房源上重新操作设备绑定后再提交!"
        //             );
        //             done(false);
        //             return false;
        //           }
        //         } else {
        //           done();
        //         }
        //       },
        //     });

        //     return false;
        //   }
        //   if (this.goSettlement == 2) {
        //     this.$toast.success("结算任务已提交!");
        //     return false;
        //   }
        // }

        this.form.source = "2";

        requestContractCreate(this.form)
          .then((res) => {
            this.$toast.success({
              message: "保存成功",

              forbidClick: true,

              onClose: () => {
                this.$router.back();

                // this.$router.push({ path: "contractList" });
              },
            });

            this.saveLoad = false;
          })

          .catch((err) => {
            this.saveLoad = false;

            console.log(err);
          });
      });
    },

    accAdd(num1, num2) {
      if (num1 && num2) {
        return accAdd(num1, num2);
      } else {
        return;
      }
    },
    accMul(num1, num2) {
      if (num1 && num2) {
        return accMul(num1, num2);
      } else {
        return 0;
      }
    },
    End(e) {
      return End(e);
    },
    //校验

    validRentType() {
      return Boolean(this.form.rentType);
    },

    validPhone(val) {
      return validPhone(val);
    },

    validEmail(val) {
      return val ? validEmail(val) : true;
    },

    validIdNo1(val) {
      if (this.form.idType == 1) {
        return validIdNo(val);
      } else {
        return true;
      }
    },
    validIdNo(val) {
      return validIdNo(val);
    },
    validNum0(val) {
      console.log(val, validNum0(val));
      return validNum0(val);
    },
     validNum(val) {
      console.log(val, validNum(val),this.form.leaseMonth,Boolean(this.form.leaseMonth));
      return validNum(val);
    },
    //预缴费校验

    advanceFeeValid1(val) {
      console.log(val);
      this.advanceIsEmpty =
        this.form.rentType == 1
          ? this.prepayment.isSharingEmpty
          : this.prepayment.isWholeEmpty;
      this.advancePrice =
        this.form.rentType == 1
          ? this.prepayment.sharingPrice
          : this.prepayment.wholePrice;
      if (!this.advanceIsEmpty && (val == 0 || val == "0")) {
        return false;
      }
    },
    advanceFeeValid2(val) {
      this.advanceIsEmpty =
        this.form.rentType == 1
          ? this.prepayment.isSharingEmpty
          : this.prepayment.isWholeEmpty;
      this.advancePrice =
        this.form.rentType == 1
          ? this.prepayment.sharingPrice
          : this.prepayment.wholePrice;
      if (!validNum0(val / this.prepayment.basePrice)) {
        return false;
      }
    },
    //正数或0，最多保留两位小数

    validNum0Decimal2(val) {
      return validNum0Decimal2(val);
    },

    // 校验押金不能小于租金

    validDeposit(val) {
      console.log(this.depositPrice);
      if(!this.depositInputEnabled){
        return true
      }else{
         let d = accMul(
            this.form.depositMonth / 1,

            this.form.rental / 1
          );
          if (Number(this.form.deposit) < Number(this.depositPrice)) {
            return false;
          }
      }
     
    },
  },

  watch: {
    active(nowData) {
      this.activeMax = nowData > this.activeMax ? nowData : this.activeMax;

      switch (nowData) {
        case 1:
          this.getMatter();
          this.getActivityList();
          break;

        case 3:
          this.getQiniuToken();

          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../common/scss/variable.scss";

#contractAdd {
  height: 100%;
}

.field {
  padding: 0.26667rem 0.42667rem;

  background: #fff;

  font-size: 0.3rem;

  line-height: 0.64rem;

  color: #323232;

  text-align: left;

  border-top: 1px solid #ebedf0;

  border-bottom: 1px solid #ebedf0;

  .button-mini {
    width: 0.5rem;

    height: 0.5rem;

    line-height: 0.5rem;

    display: inline-block;

    text-align: center;

    border: 1px solid #a2a2a2;

    border-radius: 0.1rem;

    vertical-align: middle;
  }
}

.sub {
  position: relative;

  width: 0.5rem;

  height: 0.5rem;

  background-color: transparent;

  outline: none;

  border: 1px solid #a2a2a2;

  border-radius: 0.1rem;

  vertical-align: middle;

  &::before {
    position: absolute;

    top: 0;

    right: 0;

    bottom: 0;

    left: 0;

    margin: auto;

    background-color: currentColor;

    content: "";

    height: 0.04rem;

    width: 80%;

    color: #a2a2a2;
  }
}

.add {
  position: relative;

  width: 0.5rem;

  height: 0.5rem;

  background-color: transparent;

  outline: none;

  border: 1px solid #a2a2a2;

  border-radius: 0.1rem;

  vertical-align: middle;

  &::before {
    position: absolute;

    top: 0;

    right: 0;

    bottom: 0;

    left: 0;

    margin: auto;

    background-color: currentColor;

    content: "";

    height: 0.04rem;

    width: 80%;

    color: #a2a2a2;
  }

  &::after {
    position: absolute;

    top: 0;

    right: 0;

    bottom: 0;

    left: 0;

    margin: auto;

    background-color: currentColor;

    content: "";

    height: 80%;

    width: 0.04rem;

    color: #a2a2a2;
  }
}

.unit {
  display: flex;

  padding-right: 0.42rem;

  background: #fff;

  .van-field {
    width: 80%;

    flex: 1;
  }

  .after {
    flex: 0.2;

    padding: 0.26667rem 0;

    line-height: 0.64rem;
  }
}

.search {
  width: 100%;

  height: 100%;

  position: fixed;

  top: 0;
  left: 0;
  background-color: #fff;

  z-index: 99;

  // overflow: scroll;

  .van-search {
    /deep/i {
      line-height: 0.84rem;
    }

    /deep/input {
      border: none;
    }
  }
}

.step {
  text-align: left;
}

.form1,
.form2,
.form3,
.form4 {
  height: calc(100vh - 1.8rem);

  overflow: scroll;
}

.btn {
  width: 100%;

  position: fixed;

  bottom: 0;

  border-radius: 0.1rem;

  overflow: hidden;

  display: flex;

  /deep/.van-button {
    margin-left: -1px;

    border: none;

    border-radius: 0;

    flex: 1;

    padding: 0%;

    &:not(:last-child)::after {
      height: 50%;

      position: absolute;

      box-sizing: border-box;

      content: " ";

      pointer-events: none;

      right: 0;

      top: 50%;

      transform: translateY(-50%);

      border-right: 0.02667rem solid #ebedf0;

      z-index: 99;
    }
  }
}

.form1 {
  .van-cell.border::after {
    position: absolute;

    box-sizing: border-box;

    content: " ";

    pointer-events: none;

    right: 0;

    bottom: 0;

    left: 0.42667rem;

    border-bottom: 0.02667rem solid #ebedf0;

    -webkit-transform: scaleY(0.5);

    transform: scaleY(0.5);
  }

  /deep/.van-stepper__minus::before,
  /deep/.van-stepper__plus::before {
    height: 2px;
  }

  /deep/.van-stepper__minus::after,
  /deep/.van-stepper__plus::after {
    width: 2px;
  }

  .field {
    position: relative;

    border: none;
  }

  .body {
    background-color: #fff;

    padding: 0.1rem;

    text-align: left;
    position: relative;

    &::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0.42667rem;
      bottom: 0;
      left: 0.42667rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .van-uploader {
      // margin: 0.2rem;

      /deep/.van-uploader__preview-image {
        border: 1px solid #ebedf0;
      }
    }

    .picCard {
      display: inline-block;

      margin: 0.2rem;

      width: 2.2rem;

      .text {
        text-align: center;

        .van-field {
          padding: 0;

          /deep/input {
            text-align: center;
          }
        }
      }

      .textBorder {
        /deep/.van-field__body {
          border: 1px solid $border-color;

          border-radius: 0.1rem;

          overflow: hidden;
        }
      }
    }
  }

  .body1 {
    padding: 0.3rem;
  }
}

.form3 {
  .title {
    background-color: #fff;

    text-align: left;

    padding-left: 0.2rem;
  }

  .assetsBody {
    display: flex;

    justify-content: flex-start;

    background-color: #fff;

    padding: 0.2rem 0;

    flex-wrap: wrap;

    > div {
      width: 28%;

      height: 0.8rem;

      line-height: 0.8rem;

      border: 1px solid $theme-color;

      color: $theme-color;

      text-align: center;

      margin: 0 2.5% 0.1rem;
    }
  }
}

.form4 {
  background-color: #fff;

  text-align: left;

  /deep/.van-field__error-message {
    text-align: center;
  }

  .field {
    position: relative;
  }

  .body {
    padding: 0.1rem;

    .van-uploader {
      // margin: 0.2rem;

      /deep/.van-uploader__preview-image {
        border: 1px solid #ebedf0;
      }
    }

    .picCard {
      display: inline-block;

      margin: 0.2rem;

      width: 2.2rem;

      .text {
        text-align: center;

        .van-field {
          padding: 0;

          /deep/input {
            text-align: center;
          }
        }
      }

      .textBorder {
        /deep/.van-field__body {
          border: 1px solid $border-color;

          border-radius: 0.1rem;

          overflow: hidden;
        }
      }
    }
  }

  .body1 {
    padding: 0.3rem;
  }
}
</style>
